import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import AppSelect from '../../common/AppSelect';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import ReminderMe from './ReminderMe';
import AssignDropdown from './AssignDropdown';
import ExtraAssignees from './ExtraAssignees';
import { useTicketShares, ShareChips, ShareMenuSection } from './TicketShare';
import MyDayPlanDropdown from './MyDayPlanDropdown';
import TaskDeadline from './TaskDeadline';
import TaskStatusNextStep from './TaskStatusNextStep';
import services from '../../services';
import { getMoveBlockedMessage } from '../../utils/moveBlocked';
import { useSelector } from 'react-redux';
import { useTaskData } from '../../hooks/useTaskData';
import DatePicker from 'react-datepicker';
import { FiEdit, FiLink, FiSend, FiMoreVertical, FiCopy, FiXCircle, FiPlus, FiBriefcase, FiChevronRight, FiCheck, FiLock } from 'react-icons/fi';
import AppModal from '../../common/AppModal';
import { IoIosSend } from 'react-icons/io';
import Select, { components } from 'react-select';
import DropDown from 'react-dropdown-select';
import ComposeEmail from '../composeEmail/ComposeEmail';
import { Tooltip } from 'react-tooltip';
import { useDispatch } from 'react-redux';
import { userDataLocal } from '../../utils/LocalSt';
import PNG from '../../assests/images/Png';
import { GoTag } from 'react-icons/go';
import { FaCaretRight } from 'react-icons/fa';
import { FaGripLines } from 'react-icons/fa';
import { LiaTagsSolid } from 'react-icons/lia';
import CustomTagSelect from './TagSelectDropdown';
import StatusDropdown from './StatusDropdown';
import PropertyModal from '../../common/PropertyModal';
import property from '../../api/property';
import { toast } from 'react-toastify';
import { TextField } from '@mui/material';
import fileImage from '../../assests/images/png/file.png'
import docFile from '../../assests/images/png/doc.png'
import pdfFile from '../../assests/images/png/pdf.png'
import jpgFile from '../../assests/images/png/jpg.png'
import pptFile from '../../assests/images/png/ppt.png'
import txtFile from '../../assests/images/png/txt.png'
import zipFile from '../../assests/images/png/zip.png'
import pngFile from '../../assests/images/png/png.png'
import { gmailSocket } from '../../socket';
import { PrivilegesChecker } from '../../utils/PrivilegesChecker';
import { getLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';
import { checkTicketMove, filterBoardsForUser } from '../../utils/ticketMoveGuard';
import { getTripButtonConfig, isTripButtonAllowedInList } from '../../utils/tripButtonLists';
import ConfirmationPopup from '../ConfirmationPopup';
import { Button, Modal, Table } from 'react-bootstrap';
import { CustomSwitchButton } from '../../common/CustomSwitchButton';
import { MdDeleteOutline } from "react-icons/md";
import Confirmation from '../../common/Confirmation';
import WarningModal from '../../common/WarningModal';
import CancelBookingModal from '../../common/CancelBookingModal';

const getFileIcon = (fileName) => {
    const ext = fileName?.split('.').pop().toLowerCase();

    switch (ext) {
        case 'pdf':
            return pdfFile;
        case 'doc':
        case 'docx':
            return docFile;
        case 'ppt':
        case 'pptx':
            return pptFile;
        case 'txt':
            return txtFile;
        case 'jpg':
        case 'jpeg':
            return jpgFile;
        case 'png':
            return pngFile;
        case 'zip':
        case 'rar':
        case '7z':
            return zipFile;
        default:
            return fileImage;
    }
};

const boardColors = ['#8BC34A', '#03A9F4', '#FF9800', '#E91E63', '#9C27B0', '#607D8B'];
const statusColors = [
    '#3b82f6',
    '#60a5fa',
    '#38bdf8',
    '#22d3ee',
    '#14b8a6',
    '#22c55e',
    '#a3e635',
    '#eab308',
    '#facc15',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#8b5cf6',
    '#a855f7',
    '#d1d5db',
    '#6b7280',
    '#374151',
    '#000000',
];

const TaskData = ({
    formattedBody,
    setBoardListId,
    gmailMassageID,
    taskItem,
    updateTaskMail,
    item,
    getTaskMail,
    setCurrentTask,
    setTaskDetailModal,
    setComposeStatus,
    threadData,
    setSelectedEmailData,
    selectedEmail,
    taskDetailsModal,
    selectedMail,
    setSelectedMail,
    handlegetEmailDetails,
    setSelectedEmailId,
    getemailbyid,
    selectedEmailData,
    selectedEmailUserGmailMessageId,
    selectedBoardId,
    childTaskData,
    selectedItem,
    setSelectedItem,
    threadMergedArray,
    setthreadMergedArray,
    originalEmail,
    setOriginalEmail,
    selectedUserId,
    selectedContact,
    currentTaskId,
    setCurrentTaskId,
    showAllAttachment,
    setShowAllAttachment,
    setAllAttachmentPathData,
    isMember,
    parentOrigin,
    refreshTrigger,
    onArchived,
}) => {
    const {
        selectedMyDayPlanDate,
        selectedReminderDate,
        selectedStatusNextStepDate,
        note,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked,
        updateSelectedMyDayPlanDate,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked,
        handleDateSelect,
        handleUpdateTask,
    } = useTaskData();
    const userDataRaw = getLocalStorageItem('userData');
    const [newWindow, setNewWindow] = useState(null);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [copyData, setCopyData] = useState("");
    const [modal, setModal] = useState(false);
    const [selectedBookingTrip, setSelectedBookingTrip] = useState()
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [deleteID, setDeleteID] = useState("");
    const [deleteTripId, setDeleteTripId] = useState("")
    const [modalShow, setModalShow] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const actionButtonRefs = useRef({});
    const [loading, setLoading] = useState(false);
    // Cleanup new window reference
    useEffect(() => {
        const checkClosed = () => {
            if (newWindow && newWindow.closed) {
                setNewWindow(null);
            }
        };

        const interval = setInterval(checkClosed, 1000);
        return () => clearInterval(interval);
    }, [newWindow]);

    let userData;
    if (typeof userDataRaw === 'string') {
        try {
            userData = JSON.parse(userDataRaw);
        } catch {
            userData = null;
        }
    } else {
        userData = userDataRaw;
    }
    const lastCommentRef = React.useRef(null);
    const isSubmittingCommentRef = React.useRef(false);
    const role = userData?.role;
    const name = userData?.name;
    const canArchiveTicket = role?.toLowerCase() === 'admin' || userData?.userArchiveTicket === 'allowed';
    const getColorForUser = (userName) => {
        if (!userName) return boardColors[0];
        const hash = [...userName].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const colorIndex = hash % boardColors.length;
        return boardColors[colorIndex];
    };
    const handleUpdateTaskWrapper = async (newDate, type = 'reminder') => {
        // ticket opened by link (/detail/:id): no taskItem from the board, use the open ticket's id
        await handleUpdateTask(newDate, type, taskItem?.id ? taskItem : { ...(taskItem || {}), id: currentTaskId });
        try {
            if (currentTaskId) {
                await getSingleTask(currentTaskId);
            }

            if (getTaskMail) {
                getTaskMail();
            }
        } catch (error) {
            console.error('Error in handleUpdateTaskWrapper:', error);
        }
    };
    const handleDateSelectWrapper = (date, type) => {
        handleDateSelect(date, type);
        if (type === 'myDay') {
            updateMyDayDate(date);
            updateSelectedMyDayPlanDate(date);
        }
    };

    const [propertyType, setPropertyType] = useState({ name: '', icon: null, value: '' });
    const [propertyName, setPropertyName] = useState('');
    const [displayOnCard, setDisplayOnCard] = useState(false);
    const [isOpenDeadline, setIsOpenDeadline] = useState(false);
    const [taskMail, setTaskMail] = useState([]);
    const [isOpenProjectBoard, setIsOpenProjectBoard] = useState(false);
    // true = the board dropdown was opened from "Share with another board": show only the share boards
    const [shareMenuOnly, setShareMenuOnly] = useState(false);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
    const [assignedUserName, setAssignedUserName] = useState('');
    const [showReminderMeDropdown, setShowReminderMeDropdown] = useState(false);
    const [reminderFixedPos, setReminderFixedPos] = useState(null);
    const [showNotes, setShowNotes] = useState(false);
    const [showMyDayPlanDropdown, setShowMyDayPlanDropdown] = useState(false);
    const [myDayFixedPos, setMyDayFixedPos] = useState(null);
    const [showMyDeadlineDropdown, setShowMyDeadlinDropdown] = useState(false);
    const [deadlineFixedPos, setDeadlineFixedPos] = useState(null);
    const [checkedChecklistItems, setCheckedChecklistItems] = useState({});
    const [expandedChecklistItem, setExpandedChecklistItem] = useState(null);

    // Same item text can exist in several list checklists, so items are keyed by rule + label
    const checklistItemKey = (item) => `${item?.ruleId || ''}::${item?.label}`;

    const isChecklistItemChecked = (item) => {
        const key = checklistItemKey(item);
        if (checkedChecklistItems[key] !== undefined) {
            return checkedChecklistItems[key];
        }
        return item?.value === true || item?.value === 'true';
    };

    // Each list the ticket entered with an automation checklist is its own tab (tab name = list name)
    const [activeChecklistTab, setActiveChecklistTab] = useState(null);
    // Rule ids of this ticket's mandatory checklists (from GET task by id)
    const [mandatoryChecklistRuleIds, setMandatoryChecklistRuleIds] = useState([]);
    // { ruleId: [labels] } of items that tick every item below them (from the live rule; null = not loaded yet)
    const [checklistChecksBelow, setChecklistChecksBelow] = useState(null);
    // { ruleId: { label: { boardName, listName, setsProperty } } } of items that move the ticket / set a property when checked
    const [checklistOnCheck, setChecklistOnCheck] = useState({});
    // { ruleId: [labels] } of items that must be checked in order (lock icon; null = not loaded yet)
    const [checklistInOrder, setChecklistInOrder] = useState(null);
    const itemOnCheck = (item) => checklistOnCheck?.[item?.ruleId]?.[item?.label] || null;
    const itemChecksBelow = (item) =>
        checklistChecksBelow
            ? (checklistChecksBelow[item?.ruleId] || []).includes(item?.label)
            : !!item?.checksBelow;
    // Ticking an item saves the whole list into employeeOffboardingattachment, while checklists added later by
    // automations (a new list the ticket entered) land in taskItem.checklist. Show both: saved copy wins per item.
    // taskItem is a prop that the parent does not refresh after a save: keep the latest saved copy fetched from the API
    const [freshChecklistSource, setFreshChecklistSource] = useState(null);
    const checklistSource = freshChecklistSource || taskItem;
    const mergedChecklist = (() => {
        const saved = checklistSource?.employeeOffboardingattachment?.checklist || [];
        const base = checklistSource?.checklist || [];
        const merged = base.map((b) => saved.find((o) => checklistItemKey(o) === checklistItemKey(b)) || b);
        saved.forEach((o) => {
            if (!merged.some((m) => checklistItemKey(m) === checklistItemKey(o))) merged.push(o);
        });
        return merged;
    })();
    const checklistTabs = (() => {
        const items = mergedChecklist;
        const tabs = [];
        items.forEach((item) => {
            const id = item?.ruleId || 'general';
            let tab = tabs.find((t) => t.id === id);
            if (!tab) {
                tab = { id, name: item?.listName || 'General', items: [] };
                tabs.push(tab);
            }
            tab.items.push(item);
        });
        return tabs;
    })();
    const currentChecklistTab = checklistTabs.find((t) => t.id === activeChecklistTab) || checklistTabs[0];

    // Task order rule: items with the lock icon (inOrder) must be checked in order — nothing after an unchecked
    // locked item can be checked, and a locked item cannot be unchecked while a later item stays checked.
    // Items with the chain icon are optional. Checklists without locked items keep the old "any order" behaviour.
    const tabHasOrderRule = (ruleId) =>
        checklistInOrder ? (checklistInOrder[ruleId] || []).length > 0 : mergedChecklist.some((i) => i?.ruleId === ruleId && i?.inOrder);
    const itemInOrder = (item) =>
        checklistInOrder ? (checklistInOrder[item?.ruleId] || []).includes(item?.label) : !!item?.inOrder;
    // The item that stops this tick / untick, or null when it is allowed
    const checklistOrderBlocker = (item, isChecked) => {
        if (!item?.ruleId || !tabHasOrderRule(item.ruleId)) return null;
        const key = checklistItemKey(item);
        const tab = mergedChecklist.filter((i) => i?.ruleId === item.ruleId);
        const pos = tab.findIndex((i) => checklistItemKey(i) === key);
        if (isChecked) {
            return tab.slice(0, pos).find((i) => itemInOrder(i) && !isChecklistItemChecked(i)) || null;
        }
        if (!itemInOrder(item)) return null;
        // later items this one ticked automatically are unticked with it
        const cascades = itemChecksBelow(item);
        return tab.slice(pos + 1).find((i) => isChecklistItemChecked(i) && !(cascades && i.autoCheckedBy === key)) || null;
    };

    useEffect(() => {
        setCheckedChecklistItems({});
        setExpandedChecklistItem(null);
        setActiveChecklistTab(null);
        setCheckedShiftChecklistItems({});
        setMandatoryChecklistRuleIds([]);
        setChecklistChecksBelow(null);
        setChecklistOnCheck({});
        setFreshChecklistSource(null);
    }, [taskItem?.id]);

    const [checkedShiftChecklistItems, setCheckedShiftChecklistItems] = useState({});
    const [fetchedShiftTicket, setFetchedShiftTicket] = useState(null);
    const shiftTicketId = taskItem?.shiftTaskTicketId || taskItem?.shiftTaskTicket?.id;

    useEffect(() => {
        setFetchedShiftTicket(null);
        if (!taskItem?.id || !shiftTicketId || taskItem?.shiftTaskTicket?.checklistStatus) return;

        let cancelled = false;
        (async () => {
            try {
                const res = await services.task.GET_TASK_BY_ID(taskItem.id);
                const ticket = res?.data?.data?.shiftTaskTicket;
                if (!cancelled && ticket) {
                    setFetchedShiftTicket(ticket);
                }
            } catch (error) {
                console.error('Error fetching shift ticket checklist:', error);
            }
        })();

        return () => { cancelled = true; };
    }, [taskItem?.id, shiftTicketId, taskItem?.shiftTaskTicket?.checklistStatus]);

    const effectiveShiftTicket = taskItem?.shiftTaskTicket?.checklistStatus
        ? taskItem.shiftTaskTicket
        : (fetchedShiftTicket || taskItem?.shiftTaskTicket);

    const isShiftChecklistItemChecked = (section, item) => {
        const key = `${section}-${item?.label}`;
        if (checkedShiftChecklistItems[key] !== undefined) {
            return checkedShiftChecklistItems[key];
        }
        return item?.value === true || item?.value === 'true';
    };

    const toggleShiftChecklistItem = async (section, label, isChecked) => {
        const ticketId = taskItem?.shiftTaskTicketId || effectiveShiftTicket?.id;
        const checklistStatus = effectiveShiftTicket?.checklistStatus || {};
        if (!ticketId) return;

        const key = `${section}-${label}`;
        const sectionItems = checklistStatus?.[section] || [];
        const updatedSectionItems = sectionItems.map((item) => ({
            ...item,
            value: item?.label === label ? isChecked : isShiftChecklistItemChecked(section, item),
        }));
        const updatedChecklistStatus = { ...checklistStatus, [section]: updatedSectionItems };

        setCheckedShiftChecklistItems((prev) => ({ ...prev, [key]: isChecked }));
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/shift/tickets/${ticketId}`,
                { checklistStatus: updatedChecklistStatus }
            );
            setFetchedShiftTicket((prev) => ({ ...(prev || effectiveShiftTicket), checklistStatus: updatedChecklistStatus }));
            if (currentTaskId) {
                await getSingleTask(currentTaskId);
            }
        } catch (error) {
            setCheckedShiftChecklistItems((prev) => ({ ...prev, [key]: !isChecked }));
            toast.error('Failed to update shift checklist item');
        }
    };

    const [shiftTicketStatusOverride, setShiftTicketStatusOverride] = useState(null);
    const shiftTicketStatus = shiftTicketStatusOverride || effectiveShiftTicket?.ticketStatus || 'PENDING';

    useEffect(() => {
        setShiftTicketStatusOverride(null);
    }, [taskItem?.id]);

    const updateShiftTicketStatus = async (newStatus) => {
        const ticketId = taskItem?.shiftTaskTicketId || effectiveShiftTicket?.id;
        if (!ticketId) return;

        const prevStatus = shiftTicketStatus;
        setShiftTicketStatusOverride(newStatus);
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/shift/tickets/${ticketId}`,
                { ticketStatus: newStatus }
            );
            setFetchedShiftTicket((prev) => ({ ...(prev || effectiveShiftTicket), ticketStatus: newStatus }));
            if (currentTaskId) {
                await getSingleTask(currentTaskId);
            }
        } catch (error) {
            setShiftTicketStatusOverride(prevStatus);
            toast.error('Failed to update shift task status');
        }
    };

    const saveChecklist = async (updatedChecklist) => {
        const savedAttachment = checklistSource?.employeeOffboardingattachment;
        const useOffboarding = savedAttachment?.checklist?.length > 0;
        const attachment = useOffboarding ? savedAttachment : taskItem;
        await handleUpdateTaskWrapper({ ...attachment, checklist: updatedChecklist }, 'checklist');
    };

    const toggleChecklistItem = async (key, isChecked) => {
        const now = new Date().toISOString();
        const by = name || 'Unknown';
        const target = mergedChecklist.find((item) => checklistItemKey(item) === key);
        const blocker = checklistOrderBlocker(target, isChecked);
        if (blocker) {
            // long task names are cut so the toast stays small
            const short = (text) => (String(text || '').length > 40 ? `${String(text).slice(0, 39)}…` : text);
            toast.error(
                isChecked
                    ? `Check "${short(blocker.label)}" first — tasks must be checked in order`
                    : `Uncheck "${short(blocker.label)}" first — later tasks are still checked`
            );
            return;
        }
        const targetTab = target?.ruleId || 'general';
        const targetIndex = mergedChecklist.indexOf(target);
        const cascades = !!target && itemChecksBelow(target);
        // Items of the same checklist below the target: ticked with it, and unticked with it if it ticked them
        const isBelowTarget = (item, index) => index > targetIndex && (item?.ruleId || 'general') === targetTab;

        const changed = {};
        const updatedChecklist = mergedChecklist.map((item, index) => {
            const wasChecked = isChecklistItemChecked(item);
            if (checklistItemKey(item) === key) {
                changed[key] = isChecked;
                return {
                    ...item,
                    value: isChecked ? 'true' : 'false',
                    // check log: who ticked / unticked the item and when
                    checkedBy: isChecked ? by : null,
                    checkedAt: isChecked ? now : null,
                    autoCheckedBy: null,
                    log: [...(item.log || []), { action: isChecked ? 'checked' : 'unchecked', by, at: now }],
                };
            }
            if (cascades && isBelowTarget(item, index)) {
                if (isChecked && !wasChecked) {
                    changed[checklistItemKey(item)] = true;
                    return {
                        ...item,
                        value: 'true',
                        checkedBy: by,
                        checkedAt: now,
                        autoCheckedBy: key,
                        log: [...(item.log || []), { action: 'checked', by, at: now, auto: target.label }],
                    };
                }
                if (!isChecked && wasChecked && item.autoCheckedBy === key) {
                    changed[checklistItemKey(item)] = false;
                    return {
                        ...item,
                        value: 'false',
                        checkedBy: null,
                        checkedAt: null,
                        autoCheckedBy: null,
                        log: [...(item.log || []), { action: 'unchecked', by, at: now, auto: target.label }],
                    };
                }
            }
            return { ...item, value: wasChecked ? 'true' : 'false' };
        });
        const previous = Object.fromEntries(Object.entries(changed).map(([k, v]) => [k, !v]));
        // items checked now that move the ticket / set a property (done by the server on save)
        const actionItems = updatedChecklist.filter((item) => changed[checklistItemKey(item)] === true && itemOnCheck(item));
        setCheckedChecklistItems((prev) => ({ ...prev, ...changed }));
        try {
            await saveChecklist(updatedChecklist);
            if (actionItems.length && currentTaskId) {
                const res = await services.task.GET_TASK_BY_ID(currentTaskId);
                const moved = res?.data?.data;
                const where = moved?.BoardList?.coloum ? ` — ticket is now in "${moved.BoardList.coloum}"` : '';
                toast.success(`"${actionItems[0].label}" checked${where}`);
            }
            const autoCount = Object.keys(changed).length - 1;
            if (autoCount > 0) {
                toast.success(`${autoCount} task${autoCount > 1 ? 's' : ''} below ${isChecked ? 'checked' : 'unchecked'} too`);
            }
            // if (canArchiveTicket && updatedChecklist.length > 0 && updatedChecklist.every((item) => item?.value === 'true')) {
            //     setShowArchiveConfirmation(true);
            // }
        } catch (error) {
            setCheckedChecklistItems((prev) => ({ ...prev, ...previous }));
            toast.error('Failed to update checklist item');
        }
    };

    // Replies on a checklist task: open thread (item key), text being typed, sending flag
    const [replyOpenKey, setReplyOpenKey] = useState(null);
    const [replyText, setReplyText] = useState('');
    const [replySending, setReplySending] = useState(false);
    const sendChecklistReply = async (item) => {
        const text = replyText.trim();
        if (!text || replySending || !currentTaskId) return;
        setReplySending(true);
        try {
            await services.task.CHECKLIST_REPLY(currentTaskId, { ruleId: item?.ruleId || '', label: item?.label, text });
            setReplyText('');
            await getSingleTask(currentTaskId);
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to save the reply');
        } finally {
            setReplySending(false);
        }
    };

    const [showChecklistPanel, setShowChecklistPanel] = useState(false);
    const [showAddChecklistInput, setShowAddChecklistInput] = useState(false);
    const [newChecklistText, setNewChecklistText] = useState('');
    const [isAddingChecklistItem, setIsAddingChecklistItem] = useState(false);

    const formatChecklistLogTime = (iso) => {
        if (!iso) return '';
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleString([], { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    // Manual task added by a user (not from an automation): goes to the "Custom Tasks" tab, card turns red until checked
    const addChecklistItem = async () => {
        const label = newChecklistText.trim();
        if (!label || isAddingChecklistItem) return;
        if (mergedChecklist.some((item) => !item?.ruleId && item?.label === label)) {
            toast.error('This task already exists');
            return;
        }
        setIsAddingChecklistItem(true);
        try {
            await saveChecklist([
                ...mergedChecklist.map((item) => ({ ...item, value: isChecklistItemChecked(item) ? 'true' : 'false' })),
                {
                    label,
                    value: 'false',
                    listName: 'Custom Tasks',
                    manual: true,
                    addedBy: name || 'Unknown',
                    addedAt: new Date().toISOString(),
                },
            ]);
            setNewChecklistText('');
            setShowAddChecklistInput(false);
            setActiveChecklistTab('general');
        } catch (error) {
            toast.error('Failed to add task');
        } finally {
            setIsAddingChecklistItem(false);
        }
    };

    const getDropdownFixedPosition = (element) => {
        if (!element) return null;
        const rect = element.getBoundingClientRect();
        const sidebar = element.closest('.task-detail-sidebar');
        const sidebarRect = sidebar?.getBoundingClientRect();
        const width = Math.min(300, window.innerWidth - 16);
        const anchorRight = sidebarRect?.right ?? rect.right;
        const preferredRight = window.innerWidth - anchorRight;
        const maxRight = window.innerWidth - width - 8;
        let top = rect.bottom + 4;
        const estimatedHeight = 420;
        if (top + estimatedHeight > window.innerHeight - 8) {
            top = Math.max(8, rect.top - estimatedHeight);
        }
        return {
            top,
            right: Math.min(Math.max(8, preferredRight), maxRight),
            width,
        };
    };
    const [selectedBoard, setSelectedBoard] = useState(null);
    const [clickedBellIcon, setClickedIcon] = useState(null);
    const [selectedColumnName, setSelectedColumnName] = useState(null);
    const [isReminder, setIsReminder] = useState(false);
    const [allUser, setAllUser] = useState([]);
    const boardName = getLocalStorageItem('board')
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [receiverEmails, setReceiverEmails] = useState([]);
    const [showUserDropdown, setShowUserDropdown] = useState(false);
    const [showOptionModal, setShowOptionModal] = useState(null);
    const [inputStatusEditValue, setInputStatusValue] = useState('');
    const statusTagDropdownRef = useRef(null);
    const [tagModalIndex, setTagModalIndex] = useState(null);
    const modalRef = useRef(null);
    const [defaultStatus, setDefaultStatus] = useState([]);
    const [defaultTags, setDefaultTags] = useState([]);
    const [slaTags, setSlaTags] = useState(taskItem);
    const [selecteStatusIndex, setSelecteStatusIndex] = useState(null);
    const [selectedTagColor, setSelectedTagColor] = useState('#22c55e');
    const [selectedTagItem, setSelectedTagItem] = useState(null);
    const [inputTagValue, setInputTagValue] = useState('');
    const [customeFiedId, setCustomeFieldId] = useState(null);
    const [selectedFilterTagVal, setSelectedFilterTagVal] = useState([]);
    const [customprokey, setCustomprokey] = useState([]);
    const [triggerTaskUpdate, setTriggerTaskUpdate] = useState(false);
    const [boardIdlink, setBoardIdLink] = useState('');
    const [uploadTaskAttachment, setUploadTaskAttachment] = useState([])
    const attachmentUploadRef = useRef(null);
    const [openIndex, setOpenIndex] = useState(null);
    const [confimationModal, setConfimationModal] = useState(false);
    const handleTogglePopup = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };







    const isDisabled = selectedMail?.boardId === null && !selectedMail?.boardListId;
    // last main assignee picked in AssignDropdown — "Also assigned" reloads so the main person is not listed twice
    const pickedMainUserId = useSelector((s) => s.redux?.selecteAssignUser);
    const state = useSelector(
        (state) => state.redux,
        (prev, next) => {
            return (
                prev.deadlineDate === next.deadlineDate &&
                prev.myDayDate === next.myDayDate &&
                prev.selectedReminderDate === next.selectedReminderDate &&
                prev.selectedMyDayPlanDate === next.selectedMyDayPlanDate &&
                prev.selectedStatusNextStepDate === next.selectedStatusNextStepDate &&
                prev.note === next.note &&
                prev.notesText === next.notesText &&
                prev.isMyDayChecked === next.isMyDayChecked &&
                prev.isDeadlineChecked === next.isDeadlineChecked
            );
        },
    );

    const [localNotesText, setLocalNotesText] = useState();
    const [boardList, setBoardList] = useState([]);
    const dropdownRef = useRef(null);
    const propertyRef = useRef(null);
    const notesRef = useRef(null);
    const myDayPlanDropdownRef = useRef(null);
    const myDeadlineDropdownRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [selectedBoardColor, setSelectedBoardColor] = useState(null);
    const [addPropertyData, setAddPropertyData] = useState([]);
    const [customFieldValues, setCustomFieldValues] = useState([]);
    const [statusValues, setStatusValues] = useState({});
    const [selectedTags, setSelectedTags] = useState({});
    const [singleTaskData, setSingleTaskData] = useState([]);
    const propertyTypes = [
        { name: 'Status', icon: '▶️' },
        { name: 'Tag', icon: '🏷️' },
    ];

    const handlePropertyTypeChange = (e) => {
        const selected = propertyTypes.find((pt) => pt.name === e.target.value);
        setPropertyType({
            ...selected,
            value: null,
        });
        setPropertyName(selected?.name);
    };
    const [anchorEl, setAnchorEl] = useState(null);

    const addPropertyName = (event) => {
        if (isOpenDeadline) {
            setIsOpenDeadline(false);
            setAnchorEl(null);
        } else {
            setIsOpenDeadline(true);
            setAnchorEl(event.currentTarget);
            setPropertyType({ name: '', icon: null, value: '' });
            setPropertyName('');
            setIsTypeDropdownDisabled(false);
            setPropertyId(null);
        }
    };

    const handlePropertyNameChange = (event) => {
        setPropertyName(event.target.value);
    };

    const handleDisplayOnCardChange = (event) => {
        setDisplayOnCard(event.target.checked);
    };
    const handleToggleSearchBox = () => {
        setIsSearchBoxOpen(!isSearchBoxOpen);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            addProperty();
            getTaskMailInbox();
            setIsOpenDeadline(false);
        }
    };

    const handleAssign = (e) => {};

    const getTaskMailInbox = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/addProperty/getAllAddProperty`);
            if (response) {
                setTaskMail(response?.data?.data);
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };
    const createAddProperty = async () => {
        const data = {
            type: propertyType,
            propertyName: propertyName,
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/addProperty/createaddProperty`,
                data,
            );
            if (response) {
                getTaskMailInbox();
            }
        } catch (error) {
            console.error('Error creating task mail:', error);
        }
    };

    const deleteTaskMailProperty = async (type, propertyName, id) => {
        const data = {
            type: type,
            propertyName: propertyName,
        };
        try {
            const response = await axios.delete(
                ` ${process.env.REACT_APP_BACKEND_URL}/addProperty/deleteAddProperty/${id}`,
                data,
            );
            if (response) {
                getTaskMailInbox();
            }
        } catch (error) {
            console.error('Error fetching task emails:', error);
        }
    };

    useEffect(() => {
        getTaskMailInbox();
    }, []);

    const handleClearAssignment = () => {
        setAssignedUserName('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setCommentInput(value);
        const emailMatches = value.match(/@[\w.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g) || [];
        const emailParts = emailMatches.map((e) => e.slice(1).toLowerCase());
        const matchedUsers = allUser.filter((user) => emailParts.includes(user.email.toLowerCase()));
        const matchedEmails = matchedUsers.map((u) => u.email);

        setSelectedUsers(matchedUsers);
        setReceiverEmails(matchedEmails);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowReminderMeDropdown(false);
                setReminderFixedPos(null);
            }
            if (notesRef.current && !notesRef.current.contains(event.target)) {
                setShowNotes(false);
            }
            if (myDayPlanDropdownRef.current && !myDayPlanDropdownRef.current.contains(event.target)) {
                setShowMyDayPlanDropdown(false);
                setMyDayFixedPos(null);
            }
            if (myDeadlineDropdownRef.current && !myDeadlineDropdownRef.current.contains(event.target)) {
                setShowMyDeadlinDropdown(false);
                setDeadlineFixedPos(null);
            }

            if (!event.target.closest('.user-dropdown-container')) {
                setShowUserDropdown(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleReminderChange = (e) => {
        updateNote(e.target.value);
    };

    const [nextStepNote, setNextStepNotes] = useState(null);
    const [filterStatusVal, setFilterStatusVal] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filterTagValue, setFilterTagValue] = useState([]);
    const [columnID, setColumnID] = useState('')
    const [boardID, setBoardID] = useState('')
    // Other boards/lists this ticket is shared to (it also stays on its own board)
    const ticketShares = useTicketShares(currentTaskId, boardID || taskItem?.boardId);
    const singleTaskDataListId = useRef(null);
    // Main assignee from the server — taskItem is empty when the ticket is opened by link (/detail/:id)
    const [serverMainAssignee, setServerMainAssignee] = useState(null);

    const getSingleTask = async (taskId, headers) => {

        if (!taskId) return;

        try {
            const response = await services.task.GET_TASK_BY_ID(taskId, headers);
            const singleTaskDetails = response?.data?.data;
            if (singleTaskDetails) {
                setServerMainAssignee({ id: singleTaskDetails.id, userId: singleTaskDetails.userId, User: singleTaskDetails.User });
                setFreshChecklistSource({
                    checklist: singleTaskDetails.checklist,
                    employeeOffboardingattachment: singleTaskDetails.employeeOffboardingattachment,
                });
            }
            setMandatoryChecklistRuleIds(Array.isArray(singleTaskDetails?.mandatoryChecklistRuleIds) ? singleTaskDetails.mandatoryChecklistRuleIds : []);
            if (singleTaskDetails) {
                setChecklistChecksBelow(singleTaskDetails.checklistChecksBelow || {});
                setChecklistInOrder(singleTaskDetails.checklistInOrder || {});
                setChecklistOnCheck(singleTaskDetails.checklistOnCheck || {});
            }
            setShowAllAttachment(singleTaskDetails?.attachment)
            setAllAttachmentPathData(singleTaskDetails?.attachment)
            setSingleTaskData(singleTaskDetails?.customProperty);
            singleTaskDataListId.current = singleTaskDetails?.boardListId ?? singleTaskDataListId.current;
            setCustomprokey(singleTaskDetails?.customProperty || []);
            if (singleTaskDetails?.deadline) {
                updateDeadlineDate(singleTaskDetails.deadline);
            } else {
                updateDeadlineDate(null);
            }
            if (singleTaskDetails?.addProperty?.textNotes) {
                setLocalNotesText(singleTaskDetails?.addProperty?.textNotes);
            } else {
                setLocalNotesText(null);
            }
            if (singleTaskDetails?.notes) {
                setNextStepNotes(singleTaskDetails.notes);
            } else {
                setNextStepNotes(null);
            }

            if (singleTaskDetails?.myDayPlan) {
                updateMyDayDate(singleTaskDetails.myDayPlan);
                updateSelectedMyDayPlanDate(singleTaskDetails.myDayPlan);
            } else {
                updateMyDayDate(null);
                updateSelectedMyDayPlanDate(null);
            }

            if (singleTaskDetails?.boardId) {
                setSelectedBoard(singleTaskDetails?.Board?.boardName);
                setSelectedColumnName(singleTaskDetails?.BoardList?.coloum);
                setColumnID(singleTaskDetails?.BoardList?.id)
                setBoardID(singleTaskDetails?.BoardList?.boardId)
            } else {
                setSelectedBoard(null);
                setSelectedColumnName(null);
            }

            if (singleTaskDetails?.reminder) {
                setIsReminder(true);
                updateSelectedReminderDate(singleTaskDetails.reminder);
            } else {
                setIsReminder(false);
                updateSelectedReminderDate(null);
            }

            if (singleTaskDetails?.nextStep || singleTaskDetails?.notes) {
                updateNote(singleTaskDetails?.notes);
                updateSelectedStatusNextStepDate(singleTaskDetails.nextStep);
            } else {
                updateSelectedStatusNextStepDate(null);
                updateNote(null);
            }
        } catch (error) {
            console.error('Error fetching task data:', error);
        }
    };

    useEffect(() => {
        // If a child task is provided (e.g. opening childTask[0] mail in MailInbox)
        // and that child corresponds to the currently selected email, apply its reminder
        try {
            if (!childTaskData) return;

            const childGmailId = childTaskData?.Email?.gmailMessageId || childTaskData?.gmailMessageId || childTaskData?.Email?.id;
            const currentGmailId = selectedEmail?.gmailMessageId || selectedEmailData || selectedEmailData?.gmailMessageId || getemailbyid?.id;

            if (!childGmailId || !currentGmailId) return;

            if (
                String(childGmailId) === String(currentGmailId) &&
                childTaskData?.reminder
            ) {
                setIsReminder(true);
                updateSelectedReminderDate(childTaskData.reminder);
            }
        } catch (e) {
            console.error('Error applying childTaskData reminder to TaskData:', e);
        }
    }, [childTaskData, selectedEmail, selectedEmailData, getemailbyid, updateSelectedReminderDate]);
    const [tripId, setTripId] = useState([]);
    const copyLinkHandler = async (id) => {
        try {
            if (id) {
                const link = parentOrigin + "/trip/export/" + id;
                window.open(link, "_blank");
            }
        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);
    };
    const fetchTaskTripIds = async () => {
        if (currentTaskId) {
            try {
                const response = await services.task.GET_TRIP_BY_TASKID(currentTaskId);
                const mappedTripIds = response?.data?.data;
                setTripId(mappedTripIds);
            } catch (error) {
                console.error('Error fetching task IDs:', error);
                setTripId([]);
            }
        }
    };
    useEffect(() => {
        fetchTaskTripIds();
    }, [currentTaskId, refreshTrigger]);

    const handleUpdate = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                linkStatus: !trip?.linkStatus,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);

    };
    const handleUpdateShowPrice = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                showPrice: !trip?.showPrice,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);

    };
    const handleUpdateShowDetailPrice = async (trip) => {
        try {
            await services?.task?.UPDATE_TRIP_BY_ID(trip?.id, {
                ...trip,
                showDetailPrice: !trip?.showDetailPrice,
            });
            fetchTaskTripIds()

        } catch (error) {
            console.error(error);
        }
        setOpenActionMenu(null);


    };
    const handleCopy = async () => {
        setLoading(true)
        const removeKeys = (obj, keysToRemove = []) =>
            Object.fromEntries(
                Object.entries(obj || {}).filter(
                    ([key]) => !keysToRemove.includes(key)
                )
            );

        try {
            if (!copyData?.id) {
                toast.error("Trip not selected");
                return;
            }
            const res = await services.task.GET_TRIP_BY_ID(copyData?.id);
            const tripData = res?.data?.data;

            if (!tripData) {
                toast.error("Trip data not found");
                return;
            }

            const cleanedTrip = removeKeys(tripData, [
                "id",
                "_id",
                "createdAt",
                "updatedAt",
                "tripId",
            ]);

            const updatedObject = {
                ...cleanedTrip,

                title: currentTaskId
                    ? `Ticket -${tripData.title} copied!`
                    : `${tripData.title} copied!`,

                linkStatus: false,
                showPrice: false,
                showDetailPrice: false,
                salesStatus: "new_request",

                ...(currentTaskId && {
                    taskId: currentTaskId,
                }),
            };

            await services.task.CREATE_TRIP(updatedObject);

            toast.success("Trip Copied");
            setCopyData("");
            setLoading(false)
            fetchTaskTripIds();
        } catch (error) {
            console.error(error);
            toast.error("Error copying trip");
        } finally {
            setLoading(false)
            setOpenActionMenu(null);
        }
    };
    const deleteTrip = async (id, tripId) => {
        setLoading(true)
        try {
            const response = await services.task.DELETE_TRIP(id);
            // await services.task.DELETE_TASK_TRIP(tripId)
            fetchTaskTripIds()
            toast.success("Trip deleted successfully!");
        } catch (error) {
            console.error(error);
            toast.error("Error deleting trip.");
        } finally {
            setLoading(false)
        }
    };
    const handleYes = () => {
        deleteTrip(deleteID, deleteTripId);

        setModalShow(false);
    };
    const openCancelModal = (trip) => {
        setSelectedBookingTrip(trip)
        setShowCancelModal(true);
    }
    const getBoardList = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();
            // Users only get the boards (and lists) they are assigned to
            setBoardList(await filterBoardsForUser(response?.data?.data));
        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };

    const [allCustomFieldList, setAllCustomFieldList] = useState([]);

    const getAllPropertyByTaskId = async (id, propertyName, customPropData) => {
        if (!id) return;

        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(id);
            let data = response?.data?.data || [];

            // ✅ SORT ALL CUSTOM FIELDS BY INDEX
            data = [...data].sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

            // ---------------- STATUS ----------------
            const defaultStatus = data.filter(
                (f) => f?.customField?.name === 'Status'
            );
            setDefaultStatus(defaultStatus);

            // ---------------- MATCHED FIELDS ----------------
            const matchedFields = [];
            customPropData?.forEach(({ selectedPropId, selectedFieldId }) => {
                const matches = data.filter(
                    (item) =>
                        item.customPropertyId === selectedPropId &&
                        selectedFieldId.includes(item.id)
                );
                matchedFields.push(...matches);
            });

            setFilterTagValue(matchedFields);

            // ---------------- SELECTED STATUS ----------------
            const mappedStatusValues = matchedFields.map((field) => ({
                value: field?.customField?.value,
                label: field?.customField?.value,
                color: field?.customField?.color || '#ccc',
                index: field?.index,
                id: field?.id,
            }));

            // ✅ ensure selected status also stays sorted
            setSelectedStatus(
                mappedStatusValues.sort((a, b) => a.index - b.index)
            );

            // ---------------- TAGS ----------------
            const defaultTag = data.filter(
                (f) => f?.customField?.name === 'Tag'
            );

            if (propertyName === 'Tag') {
                setDefaultTags(defaultTag);
            }

            // ---------------- TASK FIELDS ----------------
            const taskFields = data.filter(
                (f) => f?.taskId === taskItem?.id && f?.isProperty === true
            );

            // ---------------- GROUPED DATA ----------------
            const groupedStatus = {};
            const groupedTags = {};

            matchedFields.forEach((f) => {
                if (f?.customField?.name === 'Status') {
                    if (!groupedStatus[taskItem?.id]) groupedStatus[taskItem?.id] = {};
                    groupedStatus[taskItem?.id][f.customPropertyId] = f.customField;
                }

                if (f?.customField?.name === 'Tag') {
                    if (!groupedTags[taskItem?.id]) groupedTags[taskItem?.id] = {};
                    groupedTags[taskItem?.id][f.customPropertyId] = f.customField;
                }
            });

            setStatusValues(groupedStatus);
            setSelectedTags(groupedTags);

            setCustomFieldValues(taskFields || []);

        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };


    const [formattedTag, setFormattedTag] = useState([]);

    const getAllProperty = async () => {
        try {
            const response = await services.customfield.GET_ALL_CUSTOM_FIELD();

            const data = response?.data?.data || [];
            setAllCustomFieldList(data);
            const taskFields = data.filter((f) => f?.taskId === taskItem?.id && f?.isProperty === true);

            const groupedStatus = {};
            const groupedTags = {};

            data.forEach((f) => {
                if (f?.customField?.name === 'Status') {
                    if (!groupedStatus[taskItem?.id]) groupedStatus[taskItem?.id] = {};
                    groupedStatus[taskItem?.id][f.customPropertyId] = f.customField;
                }

                if (f?.customField?.name === 'Tag') {
                    if (!groupedTags[taskItem?.id]) groupedTags[taskItem?.id] = {};
                    groupedTags[taskItem?.id][f.customPropertyId] = f.customField;
                }
            });
            setCustomFieldValues(taskFields);
            setStatusValues(groupedStatus);
            setSelectedTags(groupedTags);
        } catch (error) {
            console.error('Error fetching board list:', error);
        }
    };

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBoards, setFilteredBoards] = useState([]);

    useEffect(() => {
        if (boardList && Array.isArray(boardList)) {
            setFilteredBoards(
                boardList.filter((board) => board.boardName.toLowerCase().includes(searchTerm.toLowerCase())),
            );
        }
    }, [searchTerm, boardList]);
    // Boards with a ticket process: only the lists this ticket may be moved to are offered
    const [processAllowedByBoard, setProcessAllowedByBoard] = useState({});
    useEffect(() => {
        if (!isOpenProjectBoard) return;
        const isNewTicket = selectedMail?.boardId === null;
        let cancelled = false;
        (async () => {
            try {
                const byBoard = await services.automations.LIST_PROCESS_ALLOWED(
                    isNewTicket
                        ? {}
                        : {
                            fromBoardId: boardID || taskItem?.boardId || taskItem?.BoardList?.boardId,
                            fromListId: columnID || singleTaskDataListId.current || taskItem?.BoardList?.id || taskItem?.boardListId,
                        },
                );
                if (!cancelled) setProcessAllowedByBoard(byBoard || {});
            } catch (e) {
                console.error(e);
            }
        })();
        return () => { cancelled = true; };
    }, [isOpenProjectBoard]);
    const allowedBoardLists = (board) => {
        const allowed = processAllowedByBoard[board?.id]?.allowedListIds;
        return allowed ? (board.BoardLists || []).filter((col) => allowed.includes(col.id)) : board.BoardLists || [];
    };

    const lastItem = formattedBody[formattedBody.length - 1];
    const subthreadID = lastItem?.subThreadId || '';

    // Per-list ticket permissions: adding to the destination list and (for an existing
    // ticket) moving out of its current list. Admins and managers are unrestricted.
    const isTicketMoveAllowed = (board, col) =>
        checkTicketMove({
            destBoardId: board?.id,
            destListId: col?.id,
            sourceBoardId: boardID || taskItem?.boardId || taskItem?.BoardList?.boardId,
            sourceListId:
                selectedMail?.boardId === null
                    ? null
                    : columnID || taskItem?.BoardList?.id || taskItem?.boardListId,
        });

    const handleBoardChange = async (board, col) => {
        if (!(await isTicketMoveAllowed(board, col))) {
            setIsOpenProjectBoard(false);
            return;
        }
        setColumnID(col?.id);
        setSelectedBoard(board?.boardName);
        setSelectedColumnName(col?.coloum);
        setBoardListId(col?.id);
        setBoardID(board.id);
        try {
            let taskIdToUpdate;
            if (selectedMail?.boardId === null) {
                const userData = getLocalStorageItem('userData');
                const response = await services.task.CREATE_TASK({
                    gmailMessageId: selectedEmail?.gmailMessageId,
                    boardId: board.id,
                    boardListId: col.id,
                    subThreadId: subthreadID,
                    ...(userData?.role === "User" ? { userId: userData?.id } : {}),
                });
                const newTaskId = response.data.data.id;
                setCurrentTaskId(newTaskId);
                setSelectedMail((prev) => ({
                    ...prev,
                    boardId: board.id,
                }));
                taskIdToUpdate = newTaskId;
            } else {
                taskIdToUpdate = taskItem?.id;
            }
            const data = {
                boardId: col?.boardId,
                boardListId: col?.id,
            };
            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(taskIdToUpdate, data);

            // Prepend logic: Move the task to the top of the new column
            try {
                const query = `boardId=${board.id}&boardListId=${col.id}&page=1&limit=1`;
                const tasksRes = await services.task.GET_TASK(query);
                const columnTasks = tasksRes?.data?.data?.[col.id] || [];
                const firstTask = columnTasks[0];

                if (firstTask && String(firstTask.id) !== String(taskIdToUpdate)) {
                    await services.task.MOVE_TASK_DRAG_DROP({
                        taskId: taskIdToUpdate,
                        beforeTaskId: firstTask.id,
                        afterTaskId: null,
                        boardListId: col.id,
                    });
                }
            } catch (e) {
                console.warn('Could not move task to top:', e);
            }

            getTaskMail();
            const key = `${board.id}-${col.id}`;
            const hash = [...key].reduce((acc, char) => acc + char.charCodeAt(0), 0);
            const colorIndex = hash % boardColors.length;
            setSelectedBoardColor(boardColors[colorIndex]);
            getAllUser(board.id);
        } catch (error) {
            console.error('Error updating task:', error);
            // e.g. the list's mandatory checklist is not done yet
            const blocked = getMoveBlockedMessage(error);
            if (blocked) toast.error(blocked);
        } finally {
            setIsOpenProjectBoard(false);
        }
    };
    const [activeTab, setActiveTab] = useState('comments');
    const [comments, setComments] = useState([]);
    const [hasChatPermission, setHasChatPermission] = useState(false);

    const firstRender = React.useRef(true);

    React.useEffect(() => {
        if (lastCommentRef.current) {
            if (firstRender.current) {
                lastCommentRef.current.parentElement.scrollTop = 0;
                firstRender.current = false;
            } else {
                lastCommentRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }
    }, [comments]);

    useEffect(() => {
        const checkPermission = () => {
            const permission = PrivilegesChecker('Chats') || isMember;
            setHasChatPermission(permission);
        };
        checkPermission();
    }, []);

    const [commentInput, setCommentInput] = useState('');
    const [activityLog, setActivityLog] = useState([
        { id: 1, text: 'Task created', time: 'Just now' },
        { id: 2, text: 'Assigned to user', time: '1 min ago' },
    ]);

    const extractEmailFromSendBy = (sendBy) => {
        if (!sendBy) return '';
        const emailMatch = sendBy.match(/<(.+?)>/);
        const result = emailMatch ? emailMatch[1] : sendBy;
        return result;
    };

    const ancestor = window?.location?.ancestorOrigins?.[0];

    const handleAddComment = async () => {
        if (selectedMail?.boardId === null) {
            toast.error('Please select a board and column before adding a comment.');
            return;
        }
        if (isSubmittingCommentRef.current) {
            return;
        }
        isSubmittingCommentRef.current = true;
        try {
            let sentBy = extractEmailFromSendBy(taskItem?.Email?.sentTo);
            if (selectedContact?.id) {
                taskItem.contactId = selectedContact.id;
            }
            const token = localStorage.getItem("access_token");

            let userId = null;

            if (token) {
                const payload = JSON.parse(atob(token.split(".")[1]));
                userId = payload.sub;
            }



            if (receiverEmails.length > 0) {
                const emailLinkPayload = {
                    taskId: currentTaskId,
                    gmailType: 'Gmail',
                };
                const LinkResponse = await services.task.TASK_LINK_DATA(emailLinkPayload);

                const linkId = LinkResponse?.data?.data?.id;

                if (linkId) {
                    const encodedProps = encodeURIComponent(JSON.stringify({ linkId }));
                    const childPath = `/detail/${currentTaskId}?props=${encodedProps}`;
                    const childUrl = window.location.origin + childPath;
                    const mergedUrl = `${ancestor}/kanban?redirect=${encodeURIComponent(childUrl)}`;
                    const data = {
                        taskId: currentTaskId,
                        comment: commentInput,
                        receiver: receiverEmails,
                        sender: sentBy,
                        url: mergedUrl,
                        userId
                    };
                    const res = await services.comment.SEND_COMMENT(data);
                } else {
                    console.warn(':x: No linkId found in LinkResponse');
                }
            } else {
                const payload = {
                    taskId: currentTaskId,
                    comment: commentInput,
                    userId
                };
                const resUpdate = await services.comment.CREATE_COMMENT(payload);
            }

            setCommentInput('');
            setSelectedUsers([]);
            setReceiverEmails([]);
            getComment(currentTaskId);
            getAllUser();
        } catch (error) {
            console.error(':x: Error adding comment:', error);
        } finally {
            isSubmittingCommentRef.current = false;
        }
    };

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const encodedProps = query.get('props');
        if (encodedProps) {
            const decodedProps = decodeURIComponent(encodedProps);
            const parsedProps = JSON.parse(decodedProps);
            linkData(parsedProps?.linkId);
        }
    }, [location.search]);

    const linkData = async (linkId) => {
        try {
            const response = await services.task.GET_TASK_LINK_DATA(linkId);

            const data = response?.data?.data;

            if (data) {
                setCurrentTask(data?.task);
                getComment(data?.taskId);
                getSingleTask(data?.taskId);

                setSelectedUsers(data?.task?.userId);
                setBoardIdLink(data?.task?.boardId);
                getPropertyByID(data?.task?.boardId);
            }
        } catch (error) { }
    };

    const getComment = async (id) => {
        try {
            const response = await services.comment.GET_COMMENT_BY_ID(id);
            setComments(response?.data?.data);
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
    };
    const handleUserSelection = (users) => {
        const user = users && users.length > 0 ? [users[0]] : [];
        setSelectedUsers(user);

        let newComment = commentInput
            .replace(/@[\w]+/g, '')
            .replace(/(^[\W\d]+|[\W\d]+$)/g, '')
            .replace(/@[\w-]+/g, '')
            .trim();

        if (user[0]) {
            newComment = (newComment ? newComment + ' ' : '') + '@' + user[0].name + ' ';
        }
        setCommentInput(newComment);

        const emails = user[0] ? [user[0].email] : [];
        setReceiverEmails(emails);

        setShowUserDropdown(false);
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';

        const inputDate = new Date(date);
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const targetDay = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const msPerDay = 1000 * 60 * 60 * 24;
        const daysDiff = Math.floor((targetDay - today) / msPerDay);
        const timeString = inputDate.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        if (daysDiff === 0) return `Today, ${timeString}`;
        if (daysDiff === 1) return `Tomorrow, ${timeString}`;
        if (daysDiff === 2) return `In two days, ${timeString}`;

        return inputDate.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };

    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [editedTitle, setEditedTitle] = useState(taskItem?.title || taskItem?.subject || '');
    const debounceTimerRef = useRef(null);

    useEffect(() => {
        if (!isEditingTitle) return;

        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        debounceTimerRef.current = setTimeout(() => {
            handleSaveTitle();
        }, 800);

        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, [editedTitle]);

    const handleSaveTitle = async () => {
        if (!editedTitle.trim() || editedTitle === (taskItem?.title || taskItem?.subject)) {
            setIsEditingTitle(false);
            return;
        }
        try {
            await services.task.UPDATE_TASK_GMAIL_WHATSAAP(currentTaskId, { title: editedTitle });
            if (getTaskMail) getTaskMail();
        } catch (error) {
            console.error('Error updating title:', error);
        }
        setIsEditingTitle(false);
    };
    const fileInputRef = useRef();

    const handleAttachmentFileUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
    };
    const getAllUser = async (overrideBoardId) => {
        const boardIdForUsers = typeof overrideBoardId === 'string' || typeof overrideBoardId === 'number' ? overrideBoardId :
            taskItem?.boardId || selectedBoardId || boardID || boardIdlink || location?.state?.boardId;
        if (!boardIdForUsers) return;

        try {
            const falsePagination = true;
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(
                boardIdForUsers,
                '',
                falsePagination,
            );
            const users = response?.data?.data || [];

            const uniqueUsers = Array.from(new Map(users.map((item) => [item.userId, item.User])).values());

            setAllUser(uniqueUsers);
            setSelectedUsers(uniqueUsers.length > 0 ? [uniqueUsers[0]] : []);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const getPropertyByID = async (boardId) => {
        if (!boardId) return;
        try {
            const response = await services.property.GET_PROPERTY_BY_BOARD_ID(boardId);
            setAddPropertyData(response?.data?.data);
        } catch (error) {
            console.error('Error fetching all users:', error);
        }
    };

    const userInitial = name?.charAt(0)?.toUpperCase() || 'U';

    const getInputValue = () => commentInput;

    const toggleUserDropdown = () => {
        if (!showUserDropdown) {
            setSelectedUsers([]);
        }
        setShowUserDropdown((prev) => !prev);
    };

    const titleInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isEditingTitle && titleInputRef.current && !titleInputRef.current.contains(event.target)) {
                if (debounceTimerRef.current) {
                    clearTimeout(debounceTimerRef.current);
                }
                handleSaveTitle();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isEditingTitle, editedTitle]);

    const handleNotesSave = async () => {
        try {
            const data = {
                addProperty: {
                    textNotes: localNotesText,
                },
            };
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${currentTaskId}`, data);
            dispatch(updateNotesText({ taskId: taskItem.id, notesText: localNotesText }));
            setShowNotes(false);
        } catch (error) {
            console.error('Failed to update notes:', error);
        }
    };
    const [isOpen, setIsOpen] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState('');
    const handleSelect = (subject) => {
        setSelectedLabel(subject?.subject || 'No Subject');
        setSelectedEmailData(subject?.gmailMessageId);
        handlegetEmailDetails(subject?.gmailMessageId);
        setSelectedItem(subject);
        setIsOpen(false);
    };

    const [propertyId, setPropertyId] = useState(null);

    const addProperty = async () => {
        try {
            const isUpdate = !!propertyId;

            const data = {
                property: {
                    name: propertyType?.name,
                    icon: propertyType?.icon,
                    value: null,
                    propertyName: propertyName,
                },
                boardId: location?.state?.boardId,

                isVisible: displayOnCard,
            };

            if (isUpdate) {
                const resUpdate = await services?.property?.UPDATE_PROPERTY(propertyId, data);
            } else {
                const res = await services?.property?.CREATE_PROPERTY(data);
            }

            getPropertyByID(location?.state?.boardId);
            setIsOpenDeadline(false);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    const [hoverIndex, setHoverIndex] = useState(null);

    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

    const toggleDropdown = (idx, event) => {
        if (openDropdownIndex === idx) {
            setOpenDropdownIndex(null);
            setAnchorEl(null);
            setIsOpenDeadline(false);
        } else {
            setOpenDropdownIndex(idx);
            setAnchorEl(event?.currentTarget || null); // safe access
        }
    };


    const [isTypeDropdownDisabled, setIsTypeDropdownDisabled] = useState(false);
    const [disablePropertyType, setDisablePropertyType] = useState();

    const handleAddPropertyChange = (item) => {
        setPropertyType(item?.property);
        setPropertyName(item?.property?.propertyName);
        setIsTypeDropdownDisabled(true);
        setPropertyId(item?.id);
        setDisablePropertyType(item?.id);
    };
    const [openStatusIndex, setOpenStatusIndex] = useState(null);
    const handleStatusClick = (index, type) => {
        if (type == 'forceClose') {
            setOpenStatusIndex(null);
        } else {
            setOpenStatusIndex((prev) => (prev === index ? null : index));
        }
    };
    const handlePropertyDelete = async (id) => {
        if (!id) return;
        try {
            await services?.customfield.DELETE_PROPERTY(id);
            getPropertyByID(location?.state?.boardId);

            setIsOpenDeadline(false);
            setPropertyId(null);
            setPropertyName(null);
            setPropertyType(null);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    const [customPropertyId, setCustomPropertyId] = useState(null);

    const handleUpdateCell = async (item, newValue, color, idx, flag) => {
        const propertyName = item?.property?.name == 'Tag' ? 'Tag' : 'Status';
        const data = {
            customPropertyId: item?.id,
            taskId: taskItem?.id,
            customField: {
                value: newValue,
                name: item?.property?.name,
                color: color,
            },
        };

        try {
            const response = await services?.customfield.CREATE_CUSTOM_FIELD(data);

            await getPropertyByID(location?.state?.boardId);
            await getAllPropertyByTaskId(item?.id, propertyName);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const handleUpdatedCustomField = async (item, newValue, color, field, idx) => {
        const propertyName = field == 'Tag' ? 'Tag' : 'Status';
        const data = {
            customPropertyId: item?.id,
            taskId: taskItem?.id,
            customField: {
                value: newValue,
                name: item?.property?.name,
                color: color,
            },
            index: idx,
        };

        try {
            await services?.customfield.UPDATE_CUSTOM_FIELD(customeFiedId, data);

            await getPropertyByID(location?.state?.boardId);
            await getAllPropertyByTaskId(item?.id, propertyName);
            getAllProperty();
            getSingleTask(taskItem?.id);
            setCustomeFieldId(null);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const handleRemoveCustomField = async (id) => {
        const updatedTaskData = singleTaskData?.map((item) => {
            return {
                ...item,
                selectedFieldId: item?.selectedFieldId?.filter((fieldId) => fieldId !== id),
            };
        });
        handletaskUpdate(updatedTaskData);
    };

    const taskIdForInit = currentTaskId || taskItem?.id;
    const boardIdForInit =
        taskItem?.boardId || selectedBoardId || boardID || boardIdlink || location?.state?.boardId;


    useEffect(() => {
        if (taskIdForInit) {
            getComment(taskIdForInit);
        }
    }, [taskIdForInit]);

    useEffect(() => {
        getAllUser();
        if (boardIdForInit) {
            getPropertyByID(boardIdForInit);
        }
    }, [boardIdForInit]);

    const [tags, setTags] = useState(['test tag', 'hello']);
    const [input, setInput] = useState('');

    const addTag = (e) => {
        e.preventDefault();
        const value = input.trim();
        if (value && !tags.includes(value)) {
            setTags([...tags, value]);
        }
        setInput('');
    };

    const handleSelecteTag = (item, value, color, idx, flag) => {
        const propertyId = item?.id;
        const taskId = taskItem?.id;

        const finalLabel = typeof value === 'object' ? value.label : value;

        const updatedValues = [
            {
                label: finalLabel,
                color,
                flag,
            },
        ];

        const newTagObj = {
            name: 'Tag',
            value: updatedValues,
        };

        setSelectedTags((prev) => ({
            ...prev,
            [taskId]: {
                ...(prev?.[taskId] || {}),
                [propertyId]: newTagObj,
            },
        }));

        if (customeFiedId) {
            handleUpdatedCustomField(item, updatedValues, color, 'Tag', idx);
        } else {
            handleUpdateCell(item, updatedValues, color);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!document.contains(event.target)) return;
            if (propertyRef.current && !propertyRef.current.contains(event.target)) {
                setIsOpenDeadline(false);
            }
        };

        if (isOpenDeadline) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDeadline]);

    const tagModalRef = useRef();
    const isDeletingRef = useRef(false);
    useEffect(() => {
        const handleClickOutside = (e) => {
            const isClickInsideChild = tagModalRef.current?.contains(e.target);
            const isClickInsideParent = statusTagDropdownRef.current?.contains(e.target);

            if (!isClickInsideChild && isClickInsideParent) {
                setSelectedTagColor(null);
                setSelectedTagItem(null);

                setTagModalIndex(null);
                return;
            }

            if (!isClickInsideChild && !isClickInsideParent) {
                setSelectedTagColor(null);
                setSelectedTagItem(null);

                setTagModalIndex(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [selectedTagItem, tagModalIndex, inputTagValue, selectedTagColor, customeFiedId]);

    const getContrastColor = (hex) => {
        if (!hex) return '#000';
        const c = hex.replace('#', '');
        const r = parseInt(c.substr(0, 2), 16);
        const g = parseInt(c.substr(2, 2), 16);
        const b = parseInt(c.substr(4, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 128 ? '#000' : '#fff';
    };

    const [editTagName, setEditTagName] = useState();
    const deleteCustomField = async (id, idx, status, val) => {
        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);
            getSingleTask(taskItem?.id);
            getAllProperty();
            getAllPropertyByTaskId(status?.customPropertyId || status?.id, status?.customField?.name);
            setTagModalIndex(null);
            setCustomeFieldId(null);
            handleStatusClick(openStatusIndex);
        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };

    const defaultColorMap = {
        Done: '#4ade80',
        'Working on': '#facc15',
        Stuck: '#f87171',
        'Waiting for approval': '#60a5fa',
        default: '#9ca3af',
    };

    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };

    const customStyles = {
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.color || '#F3F4F6',
            borderRadius: '6px',
            padding: '2px 4px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            fontSize: '0.875rem',
            color: '#111827',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#EF4444',
            ':hover': {
                backgroundColor: '#FECACA',
                color: '#B91C1C',
            },
        }),
    };
    const MultiValue = (props) => {
        const className = props.data.className || '';
        return (
            <div className={`flex items-center rounded-md px-2 py-1 mr-1 mb-1 text-[13px] ${className}`}>
                <span className="mr-1">{props.data.label}</span>
                <components.MultiValueRemove {...props}>
                    <span {...props.removeProps} className="ml-1 text-red-500 hover:text-red-700 cursor-pointer">
                        ×
                    </span>
                </components.MultiValueRemove>
            </div>
        );
    };

    const sla_alert_action = [
        {
            label: '🔥 SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 text-[10px]  bg-pink-100',
        },
        {
            label: '⚡SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 text-[10px]  bg-orange-100',
        },
    ];
    const formattedOptions = sla_alert_action.map((item) => ({
        label: `# ${item.label}`,
        value: item.value,
        className: item.color || '',
    }));
    const handleSlaTagChange = async (selectedOptions) => {
        const updatedSlaTags = selectedOptions.map((opt) => opt.value);
        let updatedTask;
        if (updatedSlaTags.length === 0) {
            updatedTask = {
                ...slaTags,
                addProperty: null,
            };
        } else {
            updatedTask = {
                ...slaTags,
                addProperty: {
                    ...(slaTags.addProperty || {}),
                    slaTags: updatedSlaTags,
                },
            };
        }
        try {
            const response = await services.task.UPDATE_TASK(updatedTask.id, updatedTask);
            const updated = response?.data?.data;
            setCurrentTask(updated);
            setSlaTags(updated);
        } catch (err) {
            console.error(':x: Failed to update SLA tags', err);
        }
    };
    const Option = (props) => {
        const { className = '', label } = props.data;
        return (
            <components.Option {...props}>
                <div className={` rounded-md px-2 py-1 w-[120px] ${className}`}>{label}</div>
            </components.Option>
        );
    };

    // boardList is the full list of boards used only by the "move to board" search
    // box, independent of which ticket is open — it used to be refetched on every
    // ticket navigation ([taskItem?.id]) here. The per-field getAllPropertyByTaskId
    // loop that ran alongside it read customFieldValues from the *previous* ticket
    // (stale closure at the time taskItem?.id changed) and passed a custom-property
    // id to an endpoint that expects a task id (/customField/task/:id), so it only
    // produced extra 400/404 calls with no effect — removed. getAllProperty() below
    // already fetches and derives customFieldValues for the current ticket.
   useEffect(() => {
        getBoardList();
        if (Array.isArray(customFieldValues)) {
            customFieldValues.forEach((field) => {
                if (field?.id) {
                    getAllPropertyByTaskId(field.id);
                }
            });
        }
    }, [taskItem?.id]);

    const lastSingleTaskFetchRef = useRef({ id: null, refreshTrigger: null });
    useEffect(() => {
        if (
            lastSingleTaskFetchRef.current.id === currentTaskId &&
            lastSingleTaskFetchRef.current.refreshTrigger === refreshTrigger
        ) {
            return;
        }

        if (currentTaskId || taskItem?.boardId) {
            lastSingleTaskFetchRef.current = { id: currentTaskId, refreshTrigger };
            getSingleTask(currentTaskId, {
                "x-user-id": userData?.id,
                "x-user-name": userData?.name,
                "x-socket-id": gmailSocket.id,
            });
            getAllProperty();
        }
    }, [taskItem?.boardId, taskItem?.id, currentTaskId, refreshTrigger]);

    useEffect(() => {
        if (isOpenDeadline) {
            setOpenDropdownIndex(null);
        }
    }, [isOpenDeadline]);

    function findBySelectedPropId(id, customProperty) {
        return customProperty.find((item) => item.selectedPropId === id);
    }

    const updateCustomProKey = (item, fieldId, newSelected) => {
        const propertyName = item?.property?.name;

        if (!propertyName) return;
        let updated = [...customprokey];
        const obj = findBySelectedPropId(item.id, updated);

        if (propertyName === 'Status') {
            // customProperty can hold duplicate entries for one property and the UI merges them,
            // so write the new selection into the first entry and clear the rest
            const idArray = Array.isArray(newSelected) && newSelected.length > 0
                ? newSelected.map((s) => s.id)
                : fieldId ? [fieldId] : [];
            let written = false;
            updated = updated.map((itemobj) => {
                if (itemobj.selectedPropId !== item.id) return itemobj;
                const next = { ...itemobj, selectedFieldId: written ? [] : idArray };
                written = true;
                return next;
            });
            if (!written) {
                updated.push({ selectedPropId: item.id, selectedFieldId: idArray });
            }
            setCustomprokey(updated);
            // keep the dropdown in sync right away instead of waiting for the refetch
            setSingleTaskData(updated);
            setTriggerTaskUpdate(true);
            handletaskUpdate(updated);
            return;
        }

        if (propertyName === 'Tag') {
            const idArray = newSelected.map((item) => item.id);
            if (obj?.selectedPropId) {
                updated.map((itemobj) => {
                    if (itemobj.selectedPropId == obj.selectedPropId) {
                        itemobj.selectedFieldId = idArray;
                    }
                    return itemobj;
                });
            } else {
                updated.push({
                    selectedPropId: item.id,
                    selectedFieldId: idArray,
                });
            }
        } else if (propertyName === 'Status') {
            // Support multi-select: derive id array from newSelected (same pattern as Tag)
            const idArray = Array.isArray(newSelected) && newSelected.length > 0
                ? newSelected.map((s) => s.id)
                : fieldId ? [fieldId] : [];
            if (obj?.selectedPropId) {
                updated.map((itemobj) => {
                    if (itemobj.selectedPropId == obj.selectedPropId) {
                        itemobj.selectedFieldId = idArray;
                    }
                    return itemobj;
                });
            } else {
                updated.push({
                    selectedPropId: item.id,
                    selectedFieldId: idArray,
                });
            }
        }
        setCustomprokey(updated);

        setTriggerTaskUpdate(true);
        handletaskUpdate(updated);
    };

    const handletaskUpdate = async (customProperty) => {
        let obj = [...customprokey];
        if (customProperty) {
            obj = [...customProperty];
        }

        const data = {
            customProperty: obj,
        };

        // ticket opened by its /detail/:id link: taskItem may not be loaded yet, the id comes from the URL
        const taskId = taskItem?.id || currentTaskId;
        if (!taskId) return;
        try {
            const listBefore = singleTaskDataListId.current ?? taskItem?.boardListId;
            const response = await services.task.UPDATE_TASK(taskId, data);
            const updatedProperties = response?.data?.data?.customProperty ?? [];
            setCustomprokey(updatedProperties);
            // A property-status automation can move the ticket to another list: reload the board behind the panel
            const listAfter = response?.data?.data?.boardListId;
            singleTaskDataListId.current = listAfter ?? listBefore;
            if (listAfter && listBefore && listAfter !== listBefore && getTaskMail) {
                getTaskMail();
            }
            await getSingleTask(taskId);
            await getAllProperty();
            // Only refresh the property that actually changed, not ALL properties
            // The old for-loop was firing N API calls per interaction (one per property)
            if (customProperty?.length > 0) {
                const changedPropId = customProperty[customProperty.length - 1]?.selectedPropId;
                if (changedPropId) {
                    await getAllPropertyByTaskId(changedPropId, '', updatedProperties);
                }
            }
        } catch (err) {
            console.error('Failed to update SLA tags', err);
        }
    };

    const getTagLabelByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value?.[0]?.label || null;
    };

    const getTagLabelColorByIdTag = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);

        return matchedItem?.customField?.value?.[0]?.color || null;
    };

    const getTagLabelByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.value || null;
    };

    const getTagLabelColorByIdStatus = (dataArray, id) => {
        const matchedItem = dataArray.find((item) => item.id === id);
        return matchedItem?.customField?.color || null;
    };

    function stripTags(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }
    function highlightMentions(text) {
        return text
            .split(/(\s+)/)
            .map((word, i) =>
                word.startsWith('@') ? `<span style="color:#1CA7EC;font-weight:bold;">${word}</span>` : word,
            )
            .join('');
    }
    const handleUploadTaskAttachmentFileChange = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        setUploadTaskAttachment((prev) => [...prev, ...selectedFiles]);

        const formData = new FormData();
        selectedFiles.forEach((file, index) => {
            formData.append('attachments', file);
        });

        try {
            await services.task.UPDATE_TASK(taskItem?.id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            getSingleTask(taskItem?.id)
        } catch (error) {
            console.error('Upload failed', error);
        }
        e.target.value = '';
    };


    const dropattachmentRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropattachmentRef.current && !dropattachmentRef.current.contains(event.target)) {
                setOpenIndex();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openIndex]);

    const handleClickAttachFile = () => {
        attachmentUploadRef.current.click();
    };


    const deleteAttachementFile = async (attachmentId) => {


        try {
            const response = await services.task.DELETE_TASK_ATTACHEMENT(taskItem?.id, attachmentId);

            if (response?.status == 200) {
                toast.success(response?.data?.message)
                getSingleTask(taskItem?.id)
                setOpenIndex(null)
            }
        } catch (error) {
            console.error('Upload failed', error);
        }
    }
    const [showArchiveConfirmation, setShowArchiveConfirmation] = useState(false);
    const archiveTask = async (item) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${item?.id}`, {
                isInComplete: true,
            });

            if (response && item?.boardId) {
                toast.success('Task archived successfully');
                if (typeof onArchived === 'function') {
                    onArchived(item);
                } else {
                    navigate('/app', { state: { boardName: boardName } })
                }
            }
        } catch (error) {
            console.error('Error archiving task:', error);
            if (error.response && error.response.data && error.response.data.message) {
                let taskNames = error.response.data.error.replace(/^Error updating Task:\s*/, "");


                toast.error(taskNames);
            } else {
                toast.error('Failed to archive task');
            }
        }
    };

    const handleArchiveClick = (item) => {
        if (!canArchiveTicket) return;

        setShowArchiveConfirmation(true);
    };

    const handleConfirmArchive = () => {
        archiveTask(taskItem);
        setShowArchiveConfirmation(false);
    };

    const handleCancelArchive = () => {
        setShowArchiveConfirmation(false);
    };
    const [draggingItem, setDraggingItem] = useState({ id: null, index: null });

    const handleDragStart = (item, index) => {
        setDraggingItem({ id: item.id, index });
        // setDraggingIndex(index)
    };
    const handleDragOver = (e) => e.preventDefault();
    const handleDrop = async (dropIndex, item) => {
        if (!draggingItem) return;
        const data = {
            boardId: item?.boardId,
            index: dropIndex
        }
        const response = await services.property.UPDATE_PROPERTY_BY_POSITION(draggingItem?.id, data);
        if (response?.status === 200) {
            getPropertyByID(item?.boardId)
        }
        setDraggingItem({ id: null, index: null });
    };
    const [showTripList, setShowTripList] = useState(false);
    // Company setting (bu-admin > Settings > Company Config > Trip Button Lists): lists where the
    // Create / Clone Trip icon is shown. No setting or an empty list = shown everywhere.
    const [tripButtonConfig, setTripButtonConfig] = useState(null);
    const tripListId = columnID || taskItem?.BoardList?.id || taskItem?.boardListId;
    useEffect(() => {
        getTripButtonConfig().then(setTripButtonConfig).catch(() => setTripButtonConfig(null));
    }, []);
    const showTripButton = isTripButtonAllowedInList(tripButtonConfig, tripListId);

    const handleCloseTripList = () => setShowTripList(false);
    const handleShowTripList = () => { fetchTaskTripIds(); setShowTripList(true) };
    const getUserInitials = (name = "") => {
        if (!name || typeof name !== "string") return "U";

        const firstChar = name
            .trim()
            .replace(/[^a-zA-Z]/g, "")
            .charAt(0);

        return firstChar ? firstChar.toUpperCase() : "U";
    };

    const toTitleCase = (name = "") => {
        if (!name || typeof name !== "string") return "User";

        return name
            .toLowerCase()
            .split(" ")
            .filter(Boolean)
            .map(
                word => word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    };

    const handleCreateNewTrip = () => {
        const parentUrl = parentOrigin + "/tripboard";
        const newWin = window.open(parentUrl, "_blank");

        const payload = {
            type: "TASK_DATA",
            taskId: { currentTaskId, boardId: boardID, columnId: columnID },
            fromTask: true
        };

        const sendWhenReady = (event) => {
            if (
                event.source === newWin &&
                event.data === "READY_FOR_TASK_DATA"
            ) {
                newWin.postMessage(payload, parentOrigin);
                window.removeEventListener("message", sendWhenReady);
            }
        };

        window.addEventListener("message", sendWhenReady);
        setConfimationModal(false);
    };


    const handleCloneTrip = () => {
        const parentUrl = parentOrigin + "/trip";
        const newWin = window.open(parentUrl, "_blank");

        const payload = {
            type: "CLONE_DATA",
            taskId: { currentTaskId, title: editedTitle || taskItem?.title, boardId: boardID, columnId: columnID },
            fromTask: true
        };
        const sendWhenReady = (event) => {
            if (
                event.source === newWin &&
                event.data === "READY_FOR_CLONE_DATA"
            ) {
                newWin.postMessage(payload, parentOrigin);
                window.removeEventListener("message", sendWhenReady);
            }
        };

        window.addEventListener("message", sendWhenReady);
        setConfimationModal(false);

    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openActionMenu !== null) {
                // Check if click is outside dropdown and button
                const dropdownElement = document.querySelector(".dropdown-menu.show");
                const buttonElement = actionButtonRefs.current[openActionMenu];

                if (
                    dropdownElement &&
                    !dropdownElement.contains(event.target) &&
                    buttonElement &&
                    !buttonElement.contains(event.target)
                ) {
                    setOpenActionMenu(null);
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openActionMenu]);
    return (
        <>
            <div className={`w-full h-full task-detail-sidebar ${taskDetailsModal ? 'fixed top-0  h-[91vh]  left-[78vw] z-50' : ''}`}>
                <div
                    className={`bg-white rounded-md relative px-3  ${taskDetailsModal ? 'h-full w-[22vw]' : 'h-full'
                        }  md:max-w-[30vw] flex flex-col justify-between `}
                >
                    <div
                        style={{ padding: '3% 0' }}
                        className="task-detail-icon-bar flex flex-row items-center gap-1 sticky top-0 left-0 bg-white justify-between z-30 w-full bg-white border rounded-md shadow-[0px_1px_3px_0px_rgba(0,0,0,0.02),_0px_0px_0px_1px_rgba(27,31,35,0.15)]"
                    >
                        <div className="flex flex-row items-center gap-1 ">
                            <span
                                style={{ border: "2px solid #0000008c" }}
                                className={` ms-1 circle-user mr-1 flex items-center justify-center  rounded-full ${canArchiveTicket ? 'cursor-pointer hover:bg-gray-100' : 'cursor-not-allowed opacity-50'}`}
                                title={canArchiveTicket ? 'Mark as complete' : 'You do not have permission to complete this task'}
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!canArchiveTicket) return;
                                        handleArchiveClick(item);
                                    }}
                                >
                                    <path
                                        d="M7.75 12.0001L10.58 14.8301L16.25 9.17012"
                                        stroke="#7d7d7d"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>

                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Add a Reminder"
                                onClick={() => {
                                    setShowReminderMeDropdown(!showReminderMeDropdown);
                                    setShowMyDayPlanDropdown(false);
                                    setShowMyDeadlinDropdown(false);
                                    setClickedIcon('bell');
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-bell"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Add to My Day plan"
                                onClick={() => {
                                    setShowMyDayPlanDropdown(!showMyDayPlanDropdown);
                                    setShowMyDeadlinDropdown(false);
                                    setClickedIcon('calendarIcon');
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-calendar-date"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Update a deadline"
                                onClick={() => {
                                    {
                                        setShowMyDeadlinDropdown(!showMyDeadlineDropdown), setClickedIcon('flagIcon');
                                        setShowMyDayPlanDropdown(false);
                                    }
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-flag"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                </svg>
                            </span>
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Attach File"
                            >
                                <label htmlFor="file-upload" className="cursor-pointer flex items-center justify-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        fill="currentColor"
                                        viewBox="0 0 22 22"
                                    >
                                        <path d="M16.5 6.75v7.5a4.5 4.5 0 1 1-9 0V5.25a3.75 3.75 0 1 1 7.5 0v8.25a2.25 2.25 0 1 1-4.5 0V7.5h1.5v6a.75.75 0 0 0 1.5 0V5.25a2.25 2.25 0 0 0-4.5 0v9a3.75 3.75 0 1 0 7.5 0v-7.5z" />
                                    </svg>
                                </label>

                                <input
                                    id="file-upload"
                                    type="file"
                                    ref={attachmentUploadRef}
                                    multiple
                                    accept="image/*"
                                    className="hidden"
                                    onClick={() => { attachmentUploadRef.current.value = null; }}
                                    onChange={(e) => { handleUploadTaskAttachmentFileChange(e) }}
                                />
                            </span>



                            <input
                                type="file"
                                accept=".pdf,.txt,.jpg,.jpeg,.png,.gif"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            {(
                                <span
                                    className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                    title="Task List"
                                    onClick={() => setShowChecklistPanel(!showChecklistPanel)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        fill={showChecklistPanel ? '#F5A623' : 'currentColor'}
                                        className="bi bi-star"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z" />
                                    </svg>
                                </span>
                            )}
                            <span
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Compose"
                                onClick={() => setComposeStatus(true)}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25zm2.75-1.25A1.25 1.25 0 0 0 3.5 6.75v.217l8.5 5.1 8.5-5.1V6.75A1.25 1.25 0 0 0 19.25 5.5zm16.75 2.383-8.19 4.914a.75.75 0 0 0-.82 0L3.5 7.883V17.25c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25z" />
                                </svg>
                            </span>
                            {PrivilegesChecker("trip") && (<>
                                {showTripButton && (<span className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer" title="Add Trip">
                                    <button
                                        className="primary-btn d-flex gap-2 align-items-center"
                                        style={{ padding: '0.25rem 0.5rem', fontSize: '0.875rem', whiteSpace: 'nowrap' }}
                                        onClick={() => {
                                            setConfimationModal(true);
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="27"
                                            height="27"
                                            viewBox="0 0 60 61"
                                            fill="none"
                                        >
                                            <path
                                                d="M30 55.5C43.8071 55.5 55 44.3071 55 30.5C55 16.6929 43.8071 5.5 30 5.5C16.1929 5.5 5 16.6929 5 30.5C5 44.3071 16.1929 55.5 30 55.5Z"
                                                stroke="#96A0B5"
                                                stroke-width="3.75"
                                            />
                                            <path
                                                d="M37.5 30.5H30M30 30.5H22.5M30 30.5V23M30 30.5V38"
                                                stroke="#96A0B5"
                                                stroke-width="3.75"
                                                stroke-linecap="round"
                                            />
                                        </svg>
                                    </button>


                                </span>)}
                                <span onClick={handleShowTripList}className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer" title="Trip List">
                                    <button
                                        className="dropdown-item d-flex align-items-center"
                                    >
                                        <svg width="27" height="27" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                            <path d="M264 112L376 112C380.4 112 384 115.6 384 120L384 160L256 160L256 120C256 115.6 259.6 112 264 112zM208 120L208 544L432 544L432 120C432 89.1 406.9 64 376 64L264 64C233.1 64 208 89.1 208 120zM480 160L480 544L512 544C547.3 544 576 515.3 576 480L576 224C576 188.7 547.3 160 512 160L480 160zM160 544L160 160L128 160C92.7 160 64 188.7 64 224L64 480C64 515.3 92.7 544 128 544L160 544z" stroke="#96A0B5" stroke-width="3.75" fill="#96A0B5" />
                                        </svg>

                                    </button>
                                </span>
                            </>
                            )}
                        </div>

                        <div>
                            <button
                                className="hover:bg-[#E4E4E4] rounded-full p-1 cursor-pointer"
                                title="Close"
                                onClick={taskDetailsModal ? () => { fetchTaskTripIds(), setTaskDetailModal(false) } : () => {
                                    // navigate(-1) is unreliable here: a fresh tab, reload, deep
                                    // link, or the replace:true navigations used by prev/next
                                    // ticket and DeepLinkResolver can leave this /detail/:id entry
                                    // with no real board entry behind it in history, so going back
                                    // would land nowhere or bounce back to the same page.
                                    // window.history.state.idx (set by react-router-dom v6) is 0
                                    // when this is the first entry in the session's history stack.
                                    if (window.history.state?.idx > 0) {
                                        navigate(-1);
                                    } else {
                                        navigate("/kanban");
                                    }
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    className="bi bi-x-lg"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414" />
                                </svg>
                            </button>
                        </div>



                    </div>

                    <div className="flex-1 overflow-y-auto">
                        {showChecklistPanel ? (
                            <div className="w-full p-2">
                                <button
                                    className="flex items-center gap-2 bg-transparent border-none cursor-pointer text-[13px] text-[#333] hover:bg-[#E4E4E4] rounded px-2 py-1 mb-2"
                                    onClick={() => setShowChecklistPanel(false)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-arrow-left"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                                        />
                                    </svg>
                                    {/* Back */}
                                </button>
                                <div className="flex items-center gap-x-[10px] mb-2 px-1">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#F5A623"
                                        className="bi bi-star-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187z" />
                                    </svg>
                                    <h4 className="text-[13px] font-bold text-black m-0">
                                        Task List
                                    </h4>
                                    <button
                                        type="button"
                                        title="Add task"
                                        onClick={() => setShowAddChecklistInput((v) => !v)}
                                        className="ml-auto flex items-center justify-center rounded-full cursor-pointer bg-transparent"
                                        style={{ width: 24, height: 24, border: '1px solid #1a7d3e', color: '#1a7d3e', fontSize: 18, lineHeight: 1, padding: 0 }}
                                    >
                                        +
                                    </button>
                                </div>
                                {showAddChecklistInput && (
                                    <div className="flex items-center gap-2 mx-1 mb-2">
                                        <input
                                            type="text"
                                            autoFocus
                                            value={newChecklistText}
                                            onChange={(e) => setNewChecklistText(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') addChecklistItem();
                                                if (e.key === 'Escape') setShowAddChecklistInput(false);
                                            }}
                                            placeholder="Describe the task..."
                                            className="flex-1 text-[13px] rounded border border-[#ccc] px-2 py-1"
                                            style={{ minWidth: 0 }}
                                        />
                                        <button
                                            type="button"
                                            disabled={!newChecklistText.trim() || isAddingChecklistItem}
                                            onClick={addChecklistItem}
                                            className="text-[12px] font-bold rounded px-3 py-1 border-none cursor-pointer"
                                            style={{
                                                background: '#1a7d3e',
                                                color: '#fff',
                                                opacity: !newChecklistText.trim() || isAddingChecklistItem ? 0.5 : 1,
                                            }}
                                        >
                                            Add
                                        </button>
                                    </div>
                                )}
                                {checklistTabs.length === 0 && !showAddChecklistInput && !(effectiveShiftTicket?.checklistStatus?.checklist?.length > 0 || effectiveShiftTicket?.checklistStatus?.break?.length > 0) && (
                                    <p className="text-[12px] text-[#888] px-1 m-0">No tasks yet. Use + to add one.</p>
                                )}
                                {checklistTabs.length > 1 && (
                                    <div className="flex flex-wrap gap-1 mb-2 px-1">
                                        {checklistTabs.map((tab) => {
                                            const done = tab.items.filter((i) => isChecklistItemChecked(i)).length;
                                            const active = tab.id === currentChecklistTab?.id;
                                            return (
                                                <button
                                                    key={tab.id}
                                                    type="button"
                                                    onClick={() => setActiveChecklistTab(tab.id)}
                                                    className="border-none cursor-pointer text-[12px] rounded-full px-3 py-1"
                                                    style={{
                                                        background: active ? '#1a7d3e' : '#F1F1F1',
                                                        color: active ? '#fff' : '#333',
                                                        fontWeight: active ? 600 : 400,
                                                    }}
                                                >
                                                    {tab.name} {done}/{tab.items.length}{mandatoryChecklistRuleIds.includes(tab.id) ? ' *' : ''}
                                                </button>
                                            );
                                        })}
                                    </div>
                                )}
                                {currentChecklistTab && mandatoryChecklistRuleIds.includes(currentChecklistTab.id) && (
                                    <div className="mx-1 mb-2 rounded px-2 py-1 text-[12px]" style={{ background: '#FEF2F2', color: '#B91C1C' }}>
                                        * Mandatory: check every item before moving this ticket out of {currentChecklistTab.name}
                                    </div>
                                )}
                                {currentChecklistTab && tabHasOrderRule(currentChecklistTab.id) && (
                                    <div className="mx-1 mb-2 rounded px-2 py-1 text-[12px]" style={{ background: '#F3F4F6', color: '#374151' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <FiLock size={11} style={{ flexShrink: 0 }} /> Check the locked tasks in order
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <FiLink size={11} style={{ flexShrink: 0 }} /> Optional tasks any time
                                        </div>
                                    </div>
                                )}
                                {(currentChecklistTab?.items || []).map((item) => (
                                    // a div, not a label: only the checkbox ticks / unticks (a click anywhere in the row used to)
                                    <div
                                        key={checklistItemKey(item)}
                                        className="flex items-start gap-2 px-1 py-[6px] border-b border-[#f5f5f5] last:border-b-0 text-[13px] text-[#333]"
                                    >
                                        <input
                                            type="checkbox"
                                            className="mt-[3px]"
                                            style={{ accentColor: '#1a7d3e', width: 15, height: 15 }}
                                            checked={isChecklistItemChecked(item)}
                                            onChange={() => toggleChecklistItem(checklistItemKey(item), !isChecklistItemChecked(item))}
                                        />
                                        {tabHasOrderRule(item?.ruleId) && (() => {
                                            const done = isChecklistItemChecked(item);
                                            const waiting = !done && !!checklistOrderBlocker(item, true);
                                            const Icon = done ? FiCheck : itemInOrder(item) ? FiLock : FiLink;
                                            const title = done
                                                ? 'Completed'
                                                : itemInOrder(item)
                                                  ? waiting
                                                      ? 'Mandatory in order — check the tasks above first'
                                                      : 'Mandatory in order — check this before the tasks below'
                                                  : waiting
                                                    ? 'Optional — check the locked tasks above first'
                                                    : 'Optional — can be checked any time';
                                            return (
                                                <span title={title} className="mt-[3px]" style={{ display: 'flex', flexShrink: 0, color: done ? '#1a7d3e' : waiting ? '#B91C1C' : '#6b7280' }}>
                                                    <Icon size={14} />
                                                </span>
                                            );
                                        })()}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <span
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setExpandedChecklistItem((prev) =>
                                                        prev === checklistItemKey(item) ? null : checklistItemKey(item)
                                                    );
                                                }}
                                                // hover shows the full task text; click still expands it in place
                                                title={item?.label}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: expandedChecklistItem === checklistItemKey(item) ? 'unset' : 2,
                                                    overflow: expandedChecklistItem === checklistItemKey(item) ? 'visible' : 'hidden',
                                                    ...(isChecklistItemChecked(item)
                                                        ? { textDecoration: 'line-through', color: '#A2A2A2' }
                                                        : undefined),
                                                }}
                                            >
                                                {item?.label}
                                            </span>
                                            {item?.addedBy && (
                                                <div className="text-[11px] text-[#888] mt-[2px]">
                                                    Added by {item.addedBy} · {formatChecklistLogTime(item.addedAt)}
                                                </div>
                                            )}
                                            {isChecklistItemChecked(item) && item?.checkedBy && (
                                                <div className="text-[11px] mt-[2px]" style={{ color: '#1a7d3e' }}>
                                                    ✓ Checked by {item.checkedBy} · {formatChecklistLogTime(item.checkedAt)}
                                                    {item?.autoCheckedBy ? ' (auto)' : ''}
                                                </div>
                                            )}
                                            {itemChecksBelow(item) && (
                                                <div className="text-[11px] mt-[2px]" style={{ color: '#6b7280' }}>
                                                    ↓ Checking this also checks all tasks below
                                                </div>
                                            )}
                                            {itemOnCheck(item) && (
                                                <div className="text-[11px] mt-[2px]" style={{ color: '#6b7280' }}>
                                                    ⚡ Checking this
                                                    {itemOnCheck(item).listName
                                                        ? ` moves the ticket to ${itemOnCheck(item).boardName ? `${itemOnCheck(item).boardName} / ` : ''}${itemOnCheck(item).listName}`
                                                        : ''}
                                                    {itemOnCheck(item).listName && itemOnCheck(item).setsProperty ? ' and' : ''}
                                                    {itemOnCheck(item).setsProperty ? ' sets a property status' : ''}
                                                </div>
                                            )}
                                            {/* replies on this task; clicks here must not tick the checkbox of the label */}
                                            <div className="mt-[4px]" onClick={(e) => e.preventDefault()}>
                                                {replyOpenKey === checklistItemKey(item) ? (
                                                    <div className="rounded px-2 py-1" style={{ background: '#F9FAFB', border: '1px solid #eee' }}>
                                                        {(item?.replies || []).map((r) => (
                                                            <div key={r.id || r.at} className="py-[3px] border-b border-[#f0f0f0] last:border-b-0">
                                                                <div className="text-[11px] text-[#888]">
                                                                    <span style={{ fontWeight: 600, color: '#333' }}>{r.by}</span> · {formatChecklistLogTime(r.at)}
                                                                </div>
                                                                <div className="text-[12px] text-[#333]" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                                    {r.text}
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className="flex items-end gap-1 mt-1">
                                                            {/* Enter sends, Shift+Enter starts a new line (same as the Notes field) */}
                                                            <textarea
                                                                autoFocus
                                                                value={replyText}
                                                                maxLength={2000}
                                                                rows={Math.min(5, Math.max(1, replyText.split('\n').length))}
                                                                placeholder="Write a reply… (Shift+Enter for new line)"
                                                                onChange={(e) => setReplyText(e.target.value)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                                        e.preventDefault();
                                                                        sendChecklistReply(item);
                                                                    }
                                                                    if (e.key === 'Escape') setReplyOpenKey(null);
                                                                }}
                                                                className="flex-1 text-[12px] border border-[#ddd] rounded px-2 py-1 outline-none"
                                                                style={{ minWidth: 0, resize: 'none', fontFamily: 'inherit' }}
                                                            />
                                                            <button
                                                                type="button"
                                                                disabled={!replyText.trim() || replySending}
                                                                onClick={() => sendChecklistReply(item)}
                                                                className="text-[11px] font-bold rounded px-2 py-1 border-none cursor-pointer"
                                                                style={{ background: '#1a7d3e', color: '#fff', opacity: !replyText.trim() || replySending ? 0.5 : 1 }}
                                                            >
                                                                {/* span: the app's global button style overrides the button's own text color */}
                                                                <span style={{ color: '#fff' }}>{replySending ? '…' : 'Reply'}</span>
                                                            </button>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => setReplyOpenKey(null)}
                                                            className="text-[11px] bg-transparent border-none cursor-pointer p-0 mt-1"
                                                            style={{ color: '#888' }}
                                                        >
                                                            Hide replies
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setReplyOpenKey(checklistItemKey(item));
                                                            setReplyText('');
                                                        }}
                                                        className="text-[11px] bg-transparent border-none cursor-pointer p-0"
                                                        style={{ color: '#1a7d3e' }}
                                                    >
                                                        {item?.replies?.length
                                                            ? `💬 ${item.replies.length} repl${item.replies.length > 1 ? 'ies' : 'y'} · last ${formatChecklistLogTime(item.replies[item.replies.length - 1].at)}`
                                                            : '💬 Reply'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {(effectiveShiftTicket?.checklistStatus?.checklist?.length > 0
                                    || effectiveShiftTicket?.checklistStatus?.break?.length > 0) && (
                                    <>
                                        <div className="flex items-center gap-x-[10px] mb-2 mt-3 px-1">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="#F5A623"
                                                className="bi bi-star-fill"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187z" />
                                            </svg>
                                            <h4 className="text-[13px] font-bold text-black m-0">
                                                Shift Checklist
                                            </h4>
                                            <span
                                                className="text-[10px] font-bold px-2 py-[2px] rounded-full ml-auto"
                                                style={{
                                                    background: shiftTicketStatus === 'COMPLETED' ? '#d1fae5'
                                                        : shiftTicketStatus === 'INPROGRESS' ? '#eff6ff'
                                                        : shiftTicketStatus === 'REJECT' ? '#fee2e2'
                                                        : '#fff8e1',
                                                    color: shiftTicketStatus === 'COMPLETED' ? '#059669'
                                                        : shiftTicketStatus === 'INPROGRESS' ? '#2563eb'
                                                        : shiftTicketStatus === 'REJECT' ? '#dc2626'
                                                        : '#d97706',
                                                }}
                                            >
                                                {shiftTicketStatus === 'COMPLETED' ? '✓ DONE'
                                                    : shiftTicketStatus === 'INPROGRESS' ? 'IN PROGRESS'
                                                    : shiftTicketStatus === 'REJECT' ? 'REJECTED'
                                                    : 'PENDING'}
                                            </span>
                                        </div>
                                        {shiftTicketStatus !== 'COMPLETED' && shiftTicketStatus !== 'REJECT' && (
                                            <div className="flex gap-2 px-1 mb-3">
                                                {shiftTicketStatus === 'INPROGRESS' ? (
                                                    <button
                                                        type="button"
                                                        className="flex-1 text-[11px] font-bold rounded-md py-[6px]"
                                                        style={{ background: '#1a7d3e', color: '#fff' }}
                                                        onClick={() => updateShiftTicketStatus('COMPLETED')}
                                                    >
                                                        Mark Complete
                                                    </button>
                                                ) : (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="flex-1 text-[11px] font-bold rounded-md py-[6px]"
                                                            style={{ background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe' }}
                                                            onClick={() => updateShiftTicketStatus('INPROGRESS')}
                                                        >
                                                            In Progress
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="flex-1 text-[11px] font-bold rounded-md py-[6px]"
                                                            style={{ background: '#fee2e2', color: '#dc2626', border: '1px solid #fecaca' }}
                                                            onClick={() => updateShiftTicketStatus('REJECT')}
                                                        >
                                                            Reject
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        {(effectiveShiftTicket?.checklistStatus?.checklist || []).map((item, idx) => (
                                            <label
                                                key={`shift-checklist-${item?.label}-${idx}`}
                                                className="flex items-start gap-2 px-1 py-[6px] border-b border-[#f5f5f5] last:border-b-0 cursor-pointer text-[13px] text-[#333]"
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="mt-[3px]"
                                                    style={{ accentColor: '#1a7d3e', width: 15, height: 15 }}
                                                    checked={isShiftChecklistItemChecked('checklist', item)}
                                                    disabled={shiftTicketStatus !== 'INPROGRESS'}
                                                    onChange={() => toggleShiftChecklistItem('checklist', item?.label, !isShiftChecklistItemChecked('checklist', item))}
                                                />
                                                <span
                                                    style={isShiftChecklistItemChecked('checklist', item)
                                                        ? { textDecoration: 'line-through', color: '#A2A2A2' }
                                                        : undefined}
                                                >
                                                    {item?.label}
                                                </span>
                                            </label>
                                        ))}
                                        {(effectiveShiftTicket?.checklistStatus?.break || []).map((item, idx) => (
                                            <label
                                                key={`shift-break-${item?.label}-${idx}`}
                                                className="flex items-start gap-2 px-1 py-[6px] border-b border-[#f5f5f5] last:border-b-0 cursor-pointer text-[13px] text-[#333]"
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="mt-[3px]"
                                                    style={{ accentColor: '#1a7d3e', width: 15, height: 15 }}
                                                    checked={isShiftChecklistItemChecked('break', item)}
                                                    disabled={shiftTicketStatus !== 'INPROGRESS'}
                                                    onChange={() => toggleShiftChecklistItem('break', item?.label, !isShiftChecklistItemChecked('break', item))}
                                                />
                                                <span
                                                    style={isShiftChecklistItemChecked('break', item)
                                                        ? { textDecoration: 'line-through', color: '#A2A2A2' }
                                                        : undefined}
                                                >
                                                    Break: {item?.label}
                                                </span>
                                            </label>
                                        ))}
                                    </>
                                )}
                            </div>
                        ) : (
                        <div
                            className="w-full overflow-y-auto overflow-x-hidden "
                            style={{
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                maxHeight: '100%',
                            }}
                        >
                            <div className="flex justify-between items-center pb-[5px]  border-b border-[#e0e0e0]">
                                <div className="flex-1">
                                    {isEditingTitle ? (
                                        <input
                                            ref={titleInputRef}
                                            className="text-[1.2rem] font-bold text-black mt-[10px] text-start border rounded px-2 py-1 w-full"
                                            value={editedTitle}
                                            autoFocus
                                            onChange={(e) => setEditedTitle(e.target.value)}
                                        />
                                    ) : (
                                        <h3 className="text-[1.2rem] w-full max-w-[20vw] font-bold text-black mt-[10px] text-start truncate">
                                            {editedTitle
                                                ? editedTitle
                                                : taskItem?.title
                                                    ? taskItem?.title
                                                    : taskItem?.subject}
                                        </h3>
                                    )}
                                </div>
                                <FiEdit onClick={() => setIsEditingTitle(!isEditingTitle)} />
                            </div>

                            {taskItem?.boardTaskType === 'Housekeeping' && (() => {
                                // Housekeeping tickets are titled "Clean <Room> #<n> – <Accommodation>"
                                const m = String(taskItem?.title || '').match(/^Clean\s+(.+?)\s*(?:[–-]\s+(.+))?$/);
                                if (!m) return null;
                                return (
                                    <div className="flex items-center gap-2 border rounded-md px-3 h-[40px] w-full mt-2 text-sm text-start">
                                        <i className="fas fa-bed text-[#555]" />
                                        <span className="font-semibold text-black">Room:</span>
                                        <span className="truncate" title={m[2] ? `${m[1]} – ${m[2]}` : m[1]}>
                                            {m[1]}{m[2] ? ` – ${m[2]}` : ''}
                                        </span>
                                    </div>
                                );
                            })()}

                            <div className="w-full p-[6px] mt-2">
                                {threadMergedArray && threadMergedArray.length > 1 ? (
                                    <div className="flex items-center justify-between border rounded-md px-3 h-[40px] w-full relative">
                                        <div
                                            className="flex items-center gap-2 text-sm text-[#333] w-full overflow-hidden cursor-pointer"
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            <i className="fas fa-envelope-open-text text-[#555]" />
                                            <span className="truncate">
                                                {selectedLabel ? selectedLabel : 'Email Group : Change Email thread'}
                                            </span>
                                        </div>

                                        <div className="h-[24px] w-[1px] bg-gray-300 mx-2"></div>

                                        <button
                                            className="flex-shrink-0"
                                            onClick={() => handlegetEmailDetails(selectedUserId)}
                                        >
                                            <i className="fas fa-sync text-sm text-[#666] hover:text-black" />
                                        </button>

                                        {isOpen && (
                                            <div
                                                className="absolute top-[42px] left-0 w-full bg-white border rounded-md shadow-md z-10 max-h-60 overflow-y-auto"
                                                style={{ maxWidth: '70%' }}
                                            >
                                                {threadMergedArray?.map(
                                                    (subject, index) =>
                                                        subject && (
                                                            <div
                                                                key={subject.id || index}
                                                                className={`text-sm text-gray-800 p-2 cursor-pointer hover:bg-gray-100 ${selectedItem?.id === subject.id ? 'bg-gray-200' : ''
                                                                    }`}
                                                                onClick={() => handleSelect(subject)}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <span>
                                                                        {subject?.subject?.length > 30
                                                                            ? subject.subject.slice(0, 30) + '...'
                                                                            : subject?.subject || 'No Subject'}
                                                                    </span>
                                                                    <span className="text-gray-500 ml-4">
                                                                        {new Date(subject?.createdAt).toLocaleString(
                                                                            'en-US',
                                                                            {
                                                                                month: 'short',
                                                                                day: 'numeric',
                                                                            },
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ),
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <button className="border-2 rounded w-full h-[40px] text-[#A2A2A2] text-sm">
                                        Open Email thread
                                    </button>
                                )}
                            </div>

                            <div className="relative">
                                <div className="flex gap-x-[0.5vw] justify-between items-center py-[1vw]">
                                    <button
                                        className="task-detail-board-btn text-[12px] p-2 font-medium p-[3px_84px_2px] rounded-[4px] text-[#fff] w-full p-[10px]"
                                        onClick={() => {
                                            setShareMenuOnly(false);
                                            setIsOpenProjectBoard(shareMenuOnly ? true : !isOpenProjectBoard);
                                        }}
                                        style={{ backgroundColor: selectedBoardColor || '#1a7d3e' }}
                                    >
                                        {selectedBoard == null
                                            ? 'Choose Board'
                                            : `${selectedBoard}-${selectedColumnName}`}
                                    </button>
                                </div>
                                <ShareChips shares={ticketShares.shares} busy={ticketShares.busy} onRemove={ticketShares.unshare} />
                                {ticketShares.targets.length > 0 && (
                                    <button
                                        type="button"
                                        data-testid="open-share-menu"
                                        onClick={() => {
                                            // open the dropdown with ONLY the boards/lists this user may share to
                                            setShareMenuOnly(true);
                                            setIsOpenProjectBoard(!(isOpenProjectBoard && shareMenuOnly));
                                        }}
                                        style={{ background: 'none', border: 'none', padding: '0 0 6px', cursor: 'pointer', color: '#1a7d3e', fontWeight: 600, fontSize: 12 }}
                                    >
                                        ↗ Share with another board
                                    </button>
                                )}
                                <div>
                                    {isOpenProjectBoard && (
                                        <div className="absolute right-0 mt-2 w-64 bg-white border rounded shadow-lg z-30">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                className="w-full px-4 py-2 border-b focus:outline-none"
                                            />
                                            <div className="p-1 overflow-y-auto max-h-60">
                                                <ul className="mt-1 list-none" style={{ padding: 0 }}>
                                                    {shareMenuOnly ? null : filteredBoards && filteredBoards.length > 0 ? (
                                                        filteredBoards.map((board) => (
                                                            <div key={board.id}>
                                                                <li className="border-b-2 uppercase text-[11px] text-black font-bold px-4 pt-3 pb-1 border-t first:border-none text-left">
                                                                    {board.boardName}
                                                                </li>
                                                                {allowedBoardLists(board).length > 0 && (
                                                                    <div>
                                                                        {allowedBoardLists(board).map((col) => (
                                                                            <li
                                                                                key={col.id}
                                                                                onClick={() =>
                                                                                    handleBoardChange(board, col)
                                                                                }
                                                                                className="px-4 py-2 hover:bg-gray-100 text-gray-800 cursor-pointer text-sm text-left"
                                                                            >
                                                                                {col.coloum}
                                                                            </li>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <li className="px-4 py-2 text-gray-400">No boards found</li>
                                                    )}
                                                    <ShareMenuSection
                                                        targets={ticketShares.targets}
                                                        shares={ticketShares.shares}
                                                        searchTerm={searchTerm}
                                                        busy={ticketShares.busy}
                                                        onShare={(boardId, listId) => {
                                                            setIsOpenProjectBoard(false);
                                                            ticketShares.share(boardId, listId);
                                                        }}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="flex items-center py-[0.8vw] "
                                    onClick={() => {
                                        if (isDisabled) toast.error('Please select a board first');
                                    }}
                                >
                                    <div className="w-[100%]">
                                        <div className="py-[0.8vw]">
                                            <div className="flex  border-b border-[#f5f5f5] items-center gap-x-[10px]">
                                                <div className="flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-person-circle"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                                                    </svg>
                                                </div>
                                                <AssignDropdown
                                                    selectedMail={selectedMail}
                                                    currentTaskId={currentTaskId}
                                                    handleAssign={handleAssign}
                                                    handleInputChange={handleInputChange}
                                                    handleClearAssignment={handleClearAssignment}
                                                    taskItem={taskItem?.id ? taskItem : serverMainAssignee?.id === currentTaskId ? serverMainAssignee : taskItem}
                                                    onClose={() => setIsSearchBoxOpen(false)}
                                                    selectedBoardId={boardID || taskItem?.boardId || selectedBoardId}
                                                />
                                            </div>
                                            <div className="pb-[0.4vw] pl-[26px]">
                                                <ExtraAssignees
                                                    currentTaskId={currentTaskId}
                                                    selectedBoardId={boardID || taskItem?.boardId || selectedBoardId}
                                                    sharedBoardIds={ticketShares.shares.map((s) => s.boardId)}
                                                    listKey={columnID || taskItem?.BoardList?.id || taskItem?.boardListId}
                                                    mainUserId={taskItem?.userId}
                                                    mainKey={pickedMainUserId}
                                                />
                                            </div>
                                        </div>
                                        <div className="relative w-full text-left" ref={dropdownRef}>
                                            <div
                                                className=" border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                                style={{ padding: '9px 0' }}
                                            >
                                                <div className=" flex items-center ">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-bell"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                                                    </svg>
                                                </div>
                                                <button
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                    onClick={() => {
                                                        if (!showReminderMeDropdown && dropdownRef.current) {
                                                            setReminderFixedPos(getDropdownFixedPosition(dropdownRef.current));
                                                        } else {
                                                            setReminderFixedPos(null);
                                                        }
                                                        setShowReminderMeDropdown(!showReminderMeDropdown);
                                                        setClickedIcon(null);
                                                    }}
                                                >
                                                    {selectedReminderDate
                                                        ? formatDateForDisplay(selectedReminderDate)
                                                        : 'Reminder...'}
                                                </button>
                                            </div>

                                            {showReminderMeDropdown && (
                                                <ReminderMe
                                                    selectedReminderDate={selectedReminderDate}
                                                    updateSelectedReminderDate={updateSelectedReminderDate}
                                                    updateSelectedStatusNextStepDate={updateSelectedStatusNextStepDate}
                                                    updateMyDayDate={updateMyDayDate}
                                                    updateDeadlineDate={updateDeadlineDate}
                                                    handleReminderChange={handleReminderChange}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    setIsReminder={setIsReminder}
                                                    taskItem={taskItem}
                                                    clickedBellIcon={clickedBellIcon}
                                                    setShowReminderMeDropdown={setShowReminderMeDropdown}
                                                    fixedPosition={reminderFixedPos}
                                                >
                                                    <DatePicker
                                                        selected={
                                                            selectedReminderDate ? new Date(selectedReminderDate) : null
                                                        }
                                                        onChange={(date) => updateSelectedReminderDate(date)}
                                                    />
                                                </ReminderMe>
                                            )}
                                        </div>
                                        <div className="relative w-full text-left" ref={myDayPlanDropdownRef}>
                                            <div
                                                className="border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                                style={{ padding: '9px 0' }}
                                            >
                                                <div className=" flex items-center gap-x-[10px]] ">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-calendar-date"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23" />
                                                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                                                    </svg>
                                                </div>
                                                <button
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                    onClick={() => {
                                                        if (!showMyDayPlanDropdown && myDayPlanDropdownRef.current) {
                                                            setMyDayFixedPos(getDropdownFixedPosition(myDayPlanDropdownRef.current));
                                                        } else {
                                                            setMyDayFixedPos(null);
                                                        }
                                                        setShowMyDayPlanDropdown(!showMyDayPlanDropdown);
                                                        setClickedIcon(null);
                                                        setShowMyDeadlinDropdown(false);
                                                        setDeadlineFixedPos(null);
                                                    }}
                                                >
                                                    {myDayDate ? formatDateForDisplay(myDayDate) : 'My Day plan...'}
                                                </button>
                                            </div>
                                            {showMyDayPlanDropdown && (
                                                <MyDayPlanDropdown
                                                    setSelectedMyDayPlanDate={updateSelectedMyDayPlanDate}
                                                    selectedMyDayPlanDate={selectedMyDayPlanDate}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    isOpen={showMyDayPlanDropdown}
                                                    taskItem={taskItem}
                                                    currentTaskId={currentTaskId}
                                                    onClose={() => setShowMyDayPlanDropdown(false)}
                                                    getTaskMail={getTaskMail}
                                                    handleDateSelect={handleDateSelectWrapper}
                                                    setIsMyDayChecked={updateIsMyDayChecked}
                                                    isMyDayChecked={isMyDayChecked}
                                                    clickedBellIcon={clickedBellIcon}
                                                    selectedBoardId={selectedBoardId}
                                                    fixedPosition={myDayFixedPos}
                                                />
                                            )}
                                        </div>
                                        <div className="relative w-full text-left" ref={myDeadlineDropdownRef}>
                                            <div
                                                className=" border-b py-[0.8vw] border-[#f5f5f5] flex items-center gap-x-[10px]"
                                                style={{ padding: '9px 0' }}
                                            >
                                            <div className=" flex items-center gap-x-[10px]]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-flag"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
                                                </svg>
                                            </div>

                                            <button
                                                className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                onClick={() => {
                                                    if (!showMyDeadlineDropdown && myDeadlineDropdownRef.current) {
                                                        setDeadlineFixedPos(getDropdownFixedPosition(myDeadlineDropdownRef.current));
                                                    } else {
                                                        setDeadlineFixedPos(null);
                                                    }
                                                    setShowMyDeadlinDropdown(!showMyDeadlineDropdown);
                                                    setClickedIcon(null);
                                                    setShowMyDayPlanDropdown(false);
                                                    setMyDayFixedPos(null);
                                                }}
                                            >
                                                {deadlineDate ? formatDateForDisplay(deadlineDate) : 'Deadline...'}
                                            </button>
                                            </div>

                                            {showMyDeadlineDropdown && (
                                                <TaskDeadline
                                                    currentTaskId={currentTaskId}
                                                    setSelectedMyDayPlanDate={updateSelectedMyDayPlanDate}
                                                    selectedMyDayPlanDate={selectedMyDayPlanDate}
                                                    deadlineDate={deadlineDate}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    taskItem={taskItem}
                                                    isOpen={showMyDeadlineDropdown}
                                                    onClose={() => setShowMyDeadlinDropdown(false)}
                                                    getTaskMail={getTaskMail}
                                                    handleDateSelect={handleDateSelectWrapper}
                                                    isDeadlineChecked={isDeadlineChecked}
                                                    setIsDeadlineChecked={updateIsDeadlineChecked}
                                                    clickedBellIcon={clickedBellIcon}
                                                    fixedPosition={deadlineFixedPos}
                                                />
                                            )}
                                        </div>


                                        {/* <div className="border-b py-[0.8vw] border-[#f5f5f5] flex items-start gap-x-[10px]"
                                            style={{ padding: '9px 0' }}>
                                            <div className="flex items-center gap-x-[10px]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-list"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                                </svg>
                                            </div>
                                            {/* <button
                                                className="relative text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                              
                                            >
                                                {'Add Trip'}
                                            </button>
                                        </div> */}
                                        <div
                                            className="border-b py-[0.8vw] border-[#f5f5f5] flex items-start gap-x-[10px]"
                                            style={{ padding: '9px 0' }}
                                        >
                                            <div className="flex items-center gap-x-[10px]">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-list"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                                </svg>
                                            </div>

                                            {!showNotes && (
                                                <button
                                                    onClick={() => setShowNotes(true)}
                                                    className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer"
                                                >
                                                    {localNotesText || 'Notes (Shift-Enter for new line)...'}
                                                </button>
                                            )}

                                            {showNotes && (
                                                <div
                                                    ref={notesRef}
                                                    style={{
                                                        position: 'relative',
                                                        right: 0,
                                                        p: 2,
                                                        bgcolor: 'background.body',
                                                        top: '20%',
                                                        width: '100%',
                                                        maxWidth: '85%',
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        onMouseDown={(e) => { e.preventDefault(); handleNotesSave(); setShowNotes(false); }}
                                                        style={{ position: 'absolute', top: '-4px', right: '-28px', background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '16px', lineHeight: 1, padding: '2px 4px', zIndex: 1 }}
                                                        title="Close"
                                                    >✕</button>
                                                    <TextField
                                                        fullWidth
                                                        value={localNotesText}
                                                        onChange={(e) => setLocalNotesText(e.target.value)}
                                                        onBlur={handleNotesSave}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                handleNotesSave();
                                                            }
                                                        }}
                                                        id="standard-multiline-static"
                                                        multiline
                                                        rows={4}
                                                        variant="standard"
                                                        sx={{
                                                            '& .MuiInputBase-root': {
                                                                padding: 0,
                                                            },
                                                            '& .MuiInput-input': {
                                                                padding: 0,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {showNotes ? (
                                            <div className="h-[36px] border-b border-[#f5f5f5] flex items-center gap-x-[10px]">
                                                <div className="h-[36px] flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                                                    </svg>
                                                </div>
                                                <a href="#" className="text-listdrop !text-[13px]">
                                                    Next Step...
                                                </a>
                                            </div>
                                        ) : (
                                            <div className="h-[36px] border-b border-[#f5f5f5] flex items-center gap-x-[10px]">
                                                <div className="h-[36px] flex items-center gap-x-[10px]]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-right"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                                                    </svg>
                                                </div>

                                                <TaskStatusNextStep
                                                    note={note}
                                                    handleChange={handleReminderChange}
                                                    setSelectedStatusNextStepDate={updateSelectedStatusNextStepDate}
                                                    handleUpdateTask={handleUpdateTaskWrapper}
                                                    selectedReminderDate={selectedReminderDate}
                                                    isReminder={isReminder}
                                                    selectedStatusNextStepDate={selectedStatusNextStepDate}
                                                    taskItem={taskItem}
                                                    setSelectedReminderDate={updateSelectedReminderDate}
                                                    getTaskMail={getTaskMail}
                                                    nextStepNote={nextStepNote}
                                                    currentTaskId={currentTaskId}
                                                />
                                            </div>
                                        )}

                                        <div className="">
                                            {taskMail?.map((item) => {
                                                return (
                                                    <>
                                                        <div className="relative h-[36px] flex justify-between border-b border-[#f5f5f5]  items-center gap-x-[10px]">
                                                            <a href="#" className="text-listdrop !text-[13px]">
                                                                {item?.type}
                                                            </a>
                                                            <div>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-trash"
                                                                    viewBox="0 0 16 16"
                                                                    onClick={() =>
                                                                        deleteTaskMailProperty(
                                                                            item?.type,
                                                                            item?.propertyName,
                                                                            item?.id,
                                                                        )
                                                                    }
                                                                >
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>

                                        {slaTags?.addProperty?.slaTags?.length > 0 && (
                                            <div>
                                                <div className=" border-b border-[#F5F5F5]  items-center gap-x-[10px]">
                                                    <div className="flex items-center gap-[10px]">
                                                        <LiaTagsSolid />
                                                        <div className="text-listdrop !text-[13px]">SLA Alerts...</div>
                                                    </div>

                                                    <Select
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={formattedOptions}
                                                        value={formattedOptions.filter((item) =>
                                                            (slaTags?.addProperty?.slaTags || []).includes(item.value),
                                                        )}
                                                        onChange={handleSlaTagChange}
                                                        placeholder="Choose SLA alerts..."
                                                        className="!text-[12px]"
                                                        styles={customStyles}
                                                        components={{
                                                            MultiValue,
                                                            MultiValueRemove: () => null,
                                                            Option,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {isOpenDeadline && (() => {
                                            const rect = anchorEl?.getBoundingClientRect?.();
                                            const spaceBelow = rect ? window.innerHeight - rect.bottom : 0;
                                            const top = rect
                                                ? (spaceBelow >= 320 ? rect.bottom + 4 : rect.top - 324)
                                                : 100;
                                            const left = rect
                                                ? Math.min(rect.left, window.innerWidth - 292)
                                                : 100;
                                            return (
                                            <div
                                                className={`dropdown ${isOpenDeadline ? 'open' : ''} deadline-day deadend-start kanban-dropDown`}
                                                ref={propertyRef}
                                                style={{
                                                    position: 'fixed',
                                                    top: Math.max(8, top),
                                                    left: Math.max(8, left),
                                                    background: '#fff',
                                                    border: '1px solid #e8f5e9',
                                                    borderRadius: 12,
                                                    boxShadow: '0 4px 24px rgba(26,125,62,0.10)',
                                                    padding: '20px 20px 16px',
                                                    width: 280,
                                                    boxSizing: 'border-box',
                                                    zIndex: 9999,
                                                }}
                                            >
                                                <div className="psm-inner">
                                                    <div className="psm-header">
                                                        <span className="psm-title">Property Settings</span>
                                                        <div className="psm-header-icons">
                                                            <button
                                                                className="psm-delete-btn"
                                                                title="Delete Property"
                                                                onClick={() => {
                                                                    handlePropertyDelete(propertyId);
                                                                    setIsOpenDeadline(false);
                                                                }}
                                                            >
                                                                <i className="bi bi-trash" />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="psm-divider" />

                                                    <div className="psm-field" onMouseDown={(e) => e.stopPropagation()}>
                                                        <label htmlFor="tdPropertyType" className="psm-label">Type</label>
                                                        <AppSelect
                                                            value={propertyType?.name || ''}
                                                            onChange={handlePropertyTypeChange}
                                                            placeholder="Select type"
                                                            style={{ height: '38px', fontSize: '13px', minWidth: '100%', width: '100%' }}
                                                            options={(propertyTypes || []).map(item => ({
                                                                value: item.name,
                                                                label: `${item.icon} ${item.name}`,
                                                            }))}
                                                            disabled={isTypeDropdownDisabled}
                                                        />
                                                    </div>

                                                    <div className="psm-field" onMouseDown={(e) => e.stopPropagation()}>
                                                        <label htmlFor="tdPropertyName" className="psm-label">Property Name</label>
                                                        <input
                                                            type="text"
                                                            id="tdPropertyName"
                                                            className="psm-input"
                                                            value={propertyName}
                                                            onChange={handlePropertyNameChange}
                                                            onKeyDown={handleKeyDown}
                                                            placeholder="Add property name here"
                                                        />
                                                    </div>

                                                    <div className="psm-checkbox-row" onMouseDown={(e) => e.stopPropagation()}>
                                                        <input
                                                            type="checkbox"
                                                            id="tdDisplayOnCard"
                                                            className="psm-checkbox"
                                                            checked={displayOnCard}
                                                            onChange={handleDisplayOnCardChange}
                                                        />
                                                        <label htmlFor="tdDisplayOnCard" className="psm-checkbox-label">
                                                            Display on Card{' '}
                                                            <span>(available on tags + statuses)</span>
                                                        </label>
                                                    </div>

                                                    <div className="psm-actions" onMouseDown={(e) => e.stopPropagation()}>
                                                        <button
                                                            className="psm-btn-cancel"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                setIsOpenDeadline(false);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="psm-btn-save"
                                                            onClick={addProperty}
                                                            disabled={!propertyType?.name || !propertyName}
                                                        >
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            );
                                        })()}

                                        <div className="    flex items-center gap-x-[10px] bg-[#eee]">
                                            <div className=" flex items-center gap-x-[10px]] w-100 flex-column">
                                                {addPropertyData?.map((item, idx) => {
                                                    const propertyId = item?.id;

                                                    const matchedField = Array.isArray(customFieldValues)
                                                        ? customFieldValues.find(
                                                            (field) => field.customPropertyId == propertyId,
                                                        )
                                                        : null;

                                                    const matchedTagField = Array.isArray(customFieldValues)
                                                        ? customFieldValues.find(
                                                            (field) => field?.customPropertyId === propertyId,
                                                        )
                                                        : null;
                                                    const fieldValue =
                                                        statusValues[propertyId] ||
                                                        matchedField?.customField?.value ||
                                                        '';

                                                    const tagValue =
                                                        selectedTags[propertyId] || matchedTagField?.customField?.value;

                                                    const filterTagProperty = filterTagValue?.filter(
                                                        (item) => item?.customPropertyId == propertyId,
                                                    );
                                                    const defaultTagValues = defaultTags;
                                                    const tagFieldsData =
                                                        customFieldValues?.filter(
                                                            (item) => item?.customField?.name === 'Tag',
                                                        ) || [];

                                                    const existingTagValues = new Set();

                                                    tagFieldsData.forEach((item) => {
                                                        const values = Array.isArray(item?.customField?.value)
                                                            ? item.customField.value
                                                            : [];
                                                        values.forEach((val) => existingTagValues.add(val));
                                                    });

                                                    defaultTagValues.forEach((defaultValue) => {
                                                        if (!existingTagValues.has(defaultValue)) {
                                                            tagFieldsData.push({
                                                                id: defaultValue?.id,
                                                                customField: {
                                                                    name: 'Tag',
                                                                    value: [defaultValue?.customField?.value],
                                                                },
                                                            });
                                                            existingTagValues.add(defaultValue);
                                                        }
                                                    });

                                                    // customProperty can hold duplicate entries for the same
                                                    // property (one may be empty), so merge all of them
                                                    const selectedFieldId = Array.from(
                                                        new Set(
                                                            (Array.isArray(singleTaskData) ? singleTaskData : [])
                                                                .filter((ele) => ele?.selectedPropId === propertyId)
                                                                .flatMap((ele) => ele?.selectedFieldId || []),
                                                        ),
                                                    );
                                                    const filteredFieldDetails = allCustomFieldList.filter(
                                                        (ele) => ele.customPropertyId == propertyId,
                                                    );

                                                    const renderFieldValue = () => {
                                                        if (item?.property?.name === 'Tag') {
                                                            return <div className="flex flex-wrap gap-1 mt-1"></div>;
                                                        }

                                                        return (
                                                            <span
                                                                className="text-gray-700 ml-2"
                                                                style={{
                                                                    fontSize: '12px',
                                                                    color: '#2094f3',
                                                                    backgroundColor: '#e7f3fe',
                                                                    borderColor: '#64b5f7',
                                                                    padding: '10px',
                                                                    borderRadius: '3px',
                                                                    paddingBottom: '2px',
                                                                    paddingTop: '0',
                                                                }}
                                                            >
                                                                {tagValue}
                                                            </span>
                                                        );
                                                    };

                                                    return (
                                                        <div
                                                            key={idx}
                                                            className="pb-2 w-100 bg-[#fff]   "
                                                            style={{ borderBottom: '1px solid #eee' }}
                                                        >
                                                            <div
                                                                key={item.id}
                                                                draggable
                                                                onMouseEnter={() => setHoverIndex(idx)}
                                                                onDragStart={() => handleDragStart(item, idx)}    // pass both item & index
                                                                onDragOver={handleDragOver}                       // allow drop
                                                                onDrop={() => handleDrop(idx, item)}              // pass target item & index
                                                                onDragEnd={() => setDraggingItem({ id: null, index: null })}
                                                                className={`flex justify-content-between align-items-center w-100 gap-2 items-center relative p-2 transition-all duration-150 ${draggingItem.id === item.id ? "opacity-50 bg-blue-50" : ""
                                                                    }`}
                                                            >
                                                                <div
                                                                    className="flex gap-2 w-100"
                                                                    onClick={() => {
                                                                        if (item?.property?.name === 'Status') {
                                                                            handleStatusClick(idx);

                                                                            getAllPropertyByTaskId(
                                                                                item?.id,
                                                                                item?.property?.name,
                                                                            );

                                                                            setShowOptionModal(null);
                                                                        } else if (item?.property?.name === 'Tag') {
                                                                            getSingleTask(taskItem?.id);
                                                                            handleStatusClick(idx);
                                                                            getAllPropertyByTaskId(
                                                                                item?.id,
                                                                                item?.property?.name,
                                                                            );

                                                                            setShowOptionModal(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    <span
                                                                        className={`${item?.property?.name === 'Tag' &&
                                                                            (!fieldValue || fieldValue.length === 0)
                                                                            ? 'text-gray-400'
                                                                            : ''
                                                                            }  inline-block`}
                                                                        style={{ fontSize: '9px' }}
                                                                    >
                                                                        {item?.property?.icon}
                                                                    </span>

                                                                    <span className="text-listdrop !text-[13px] bg-transparent border-none cursor-pointer">
                                                                        {item?.property?.propertyName ||
                                                                            item?.property?.fieldType}
                                                                    </span>
                                                                </div>

                                                                {hoverIndex === idx && (
                                                                    <span
                                                                        className="cursor-pointer"
                                                                        onClick={() => {
                                                                            handleStatusClick(idx, 'forceClose');
                                                                            toggleDropdown(idx);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="16"
                                                                            height="16"
                                                                            fill="currentColor"
                                                                            className="bi bi-caret-down-circle"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                                                            <path d="M3.7 6.7a1 1 0 0 1 1.4 0L8 9.6l2.9-2.9a1 1 0 1 1 1.4 1.4l-3.6 3.6a1 1 0 0 1-1.4 0l-3.6-3.6a1 1 0 0 1 0-1.4z" />
                                                                        </svg>
                                                                    </span>
                                                                )}

                                                                {openDropdownIndex === idx && (
                                                                    <div
                                                                        ref={propertyRef}
                                                                        className="absolute z-10 bg-white shadow-md rounded px-1 py-1 text-sm mt-2 w-full"
                                                                        style={{ right: '0' }}
                                                                    >
                                                                        <div className="hover:bg-gray-100 cursor-pointer px-2 py-1 rounded d-flex align-items-center justify-content-between">
                                                                            <span
                                                                                onClick={(event) => {
                                                                                    const rect = event.currentTarget.getBoundingClientRect();
                                                                                    handleAddPropertyChange(item);
                                                                                    setAnchorEl({ getBoundingClientRect: () => rect });
                                                                                    setIsOpenDeadline(true);
                                                                                }}
                                                                            >
                                                                                {' '}
                                                                                <i className="bi bi-gear me-2"></i>{' '}
                                                                                Property Settings
                                                                            </span>{' '}
                                                                            <img
                                                                                src="/assets/cross.svg"
                                                                                style={{
                                                                                    width: '16px',
                                                                                    opacity: '0.6',
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    setOpenDropdownIndex(null);
                                                                                    setAnchorEl(null);
                                                                                    setIsOpenDeadline(false);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {((item?.property?.name === 'Status' &&
                                                                openStatusIndex === idx) ||
                                                                (item?.property?.name === 'Tag' &&
                                                                    openStatusIndex === idx) ||
                                                                (renderFieldValue() &&
                                                                    renderFieldValue().props &&
                                                                    renderFieldValue().props.children)) && (
                                                                    <div className="" ref={statusTagDropdownRef}>
                                                                        {item?.property?.name === 'Status' &&
                                                                            openStatusIndex === idx ? (
                                                                            <div>
                                                                                <StatusDropdown
                                                                                    item={item}
                                                                                    idx={idx}
                                                                                    StatusFields={defaultStatus}
                                                                                    handleUpdateCell={handleUpdateCell}
                                                                                    handleStatusClick={handleStatusClick}
                                                                                    handleUpdatedCustomField={
                                                                                        handleUpdatedCustomField
                                                                                    }
                                                                                    deleteCustomField={deleteCustomField}
                                                                                    getDefaultColorByValue={
                                                                                        getDefaultColorByValue
                                                                                    }
                                                                                    statusColors={statusColors}
                                                                                    setSelecteStatusIndex={
                                                                                        setSelecteStatusIndex
                                                                                    }
                                                                                    selecteStatusIndex={selecteStatusIndex}
                                                                                    customeFiedId={customeFiedId}
                                                                                    setCustomeFieldId={setCustomeFieldId}
                                                                                    filterStatusVal={filterStatusVal}
                                                                                    taskItem={taskItem}
                                                                                    handletaskUpdate={handletaskUpdate}
                                                                                    customprokey={customprokey}
                                                                                    setCustomprokey={setCustomprokey}
                                                                                    updateCustomProKey={updateCustomProKey}
                                                                                    triggerTaskUpdate={triggerTaskUpdate}
                                                                                    setTriggerTaskUpdate={
                                                                                        setTriggerTaskUpdate
                                                                                    }
                                                                                    getAllProperty={getAllProperty}
                                                                                    selectedStatus={selectedStatus}
                                                                                    selectedFieldId={selectedFieldId}
                                                                                    setSelectedStatus={setSelectedStatus}
                                                                                    getPropertyByID={getPropertyByID}
                                                                                    getAllPropertyByTaskId={getAllPropertyByTaskId}
                                                                                />
                                                                            </div>
                                                                        ) : item?.property?.name === 'Tag' &&
                                                                            openStatusIndex === idx ? (
                                                                            <div key={idx}>
                                                                                <CustomTagSelect
                                                                                    item={item}
                                                                                    idx={idx}
                                                                                    openStatusIndex={openStatusIndex}
                                                                                    setOpenStatusIndex={setOpenStatusIndex}
                                                                                    handleStatusClick={handleStatusClick}
                                                                                    taskItem={taskItem}
                                                                                    statusColors={statusColors}
                                                                                    tagFieldsData={defaultTags}
                                                                                    selectedTags={selectedTags}
                                                                                    handleSelecteTag={handleSelecteTag}
                                                                                    setSelectedTagColor={
                                                                                        setSelectedTagColor
                                                                                    }
                                                                                    setSelectedFilterTagVal={
                                                                                        setSelectedFilterTagVal
                                                                                    }
                                                                                    selectedFilterTagVal={
                                                                                        selectedFilterTagVal
                                                                                    }
                                                                                    customeFiedId={customeFiedId}
                                                                                    setCustomeFieldId={setCustomeFieldId}
                                                                                    deleteCustomField={deleteCustomField}
                                                                                    editTagName={editTagName}
                                                                                    setEditTagName={setEditTagName}
                                                                                    handletaskUpdate={handletaskUpdate}
                                                                                    customprokey={customprokey}
                                                                                    setCustomprokey={setCustomprokey}
                                                                                    updateCustomProKey={updateCustomProKey}
                                                                                    triggerTaskUpdate={triggerTaskUpdate}
                                                                                    selectedFieldId={selectedFieldId}
                                                                                    setTriggerTaskUpdate={
                                                                                        setTriggerTaskUpdate
                                                                                    }
                                                                                    filterTagProperty={filterTagProperty}
                                                                                    getPropertyByID={getPropertyByID}
                                                                                    getAllProperty={getAllProperty}
                                                                                    getAllPropertyByTaskId={getAllPropertyByTaskId}
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            renderFieldValue()
                                                                        )}
                                                                    </div>
                                                                )}

                                                            {item?.property?.name === 'Tag' &&
                                                                selectedFieldId.length > 0 && (
                                                                    <div className="flex flex-wrap gap-1">
                                                                        {selectedFieldId.map(
                                                                            (selectedField, SelectedIndex) => {
                                                                                if (
                                                                                    getTagLabelByIdTag(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    )
                                                                                ) {
                                                                                    return (
                                                                                        <span
                                                                                            key={SelectedIndex}
                                                                                            className="text-xs rounded p-1 px-2 font-medium"
                                                                                            style={{
                                                                                                color:
                                                                                                    getTagLabelColorByIdTag(
                                                                                                        filteredFieldDetails,
                                                                                                        selectedField,
                                                                                                    ) || '#1a7d3e',
                                                                                                border: `1px solid ${getTagLabelColorByIdTag(
                                                                                                    filteredFieldDetails,
                                                                                                    selectedField,
                                                                                                ) || '#1a7d3e'
                                                                                                    }`,
                                                                                                borderRadius: '999px',
                                                                                            }}
                                                                                        >
                                                                                            #
                                                                                            {getTagLabelByIdTag(
                                                                                                filteredFieldDetails,
                                                                                                selectedField,
                                                                                            )}
                                                                                        </span>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            },
                                                                        )}
                                                                    </div>
                                                                )}

                                                            {item?.property?.name === 'Status' &&
                                                                selectedFieldId.length > 0 &&
                                                                selectedFieldId.map((selectedField, SelectedIndex) => {
                                                                    if (
                                                                        getTagLabelByIdStatus(
                                                                            filteredFieldDetails,
                                                                            selectedField,
                                                                        )
                                                                    ) {
                                                                        return (
                                                                            <div>
                                                                                <span
                                                                                    key={SelectedIndex}
                                                                                    className="text-xs rounded p-1 px-2 font-medium"
                                                                                    style={{
                                                                                        color: 'white',
                                                                                        background: `${getTagLabelColorByIdStatus(
                                                                                            filteredFieldDetails,
                                                                                            selectedField,
                                                                                        ) || 'grey'
                                                                                            }`,
                                                                                        borderRadius: '999px',
                                                                                    }}
                                                                                >
                                                                                    {getTagLabelByIdStatus(
                                                                                        filteredFieldDetails,
                                                                                        selectedField,
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                        );
                                                                    }
                                                                })}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-x-[10px]] mb-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    fill="currentColor"
                                    viewBox="0 0 22 22"
                                >
                                    <path d="M16.5 6.75v7.5a4.5 4.5 0 1 1-9 0V5.25a3.75 3.75 0 1 1 7.5 0v8.25a2.25 2.25 0 1 1-4.5 0V7.5h1.5v6a.75.75 0 0 0 1.5 0V5.25a2.25 2.25 0 0 0-4.5 0v9a3.75 3.75 0 1 0 7.5 0v-7.5z" />
                                </svg>
                                <input
                                    id="file-upload"
                                    type="file"
                                    ref={attachmentUploadRef}
                                    multiple
                                    accept="image/*"
                                    className="hidden"
                                    onClick={() => { attachmentUploadRef.current.value = null; }}
                                    onChange={(e) => { handleUploadTaskAttachmentFileChange(e); }}
                                />

                                <button
                                    className=" text-secondary px-2 py-1 rounded text-xs font-semibold transition "
                                    onClick={() => attachmentUploadRef.current && attachmentUploadRef.current.click()}
                                >
                                    Upload
                                </button>
                            </div>
            {PrivilegesChecker("add_a_property") && (
                            <div className="relative w-full">
                                <div className="add-property relative flex gap-[15px] items-center border border-[#f5f5f5] text-[.7rem] mt-[17px] border-b-[5px] border-[#f5f5f5]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-plus-lg text-[#1a7d3e]"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg>
                                    <h3
                                        onClick={addPropertyName}
                                        style={{
                                            color: '#1a7d3e',
                                            position: 'relative',
                                            marginBottom: '0.5rem',
                                            marginTop: '0.5rem',
                                            cursor: 'pointer',
                                            fontWeight: 600,
                                        }}
                                    >
                                        Add a property
                                    </h3>
                                </div>
                            </div>
                            )}

                            <div>
                                {showAllAttachment?.length > 0 ? <>
                                    <div className="flex justify-between  text-[#757575] p-1 text-[0.7rem]" >
                                        <div>Attachment ({showAllAttachment?.length})</div>
                                        <div className='cursor-pointer' onClick={handleClickAttachFile}>Attach File</div>
                                    </div>


                                </> : null}

                                <div className="mt-1 flex flex-col gap-2">
                                    {showAllAttachment?.map((file, index) => {
                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${file?.finalName}`;
                                        const ext = file.finalName.split('.').pop().toLowerCase();




                                        return (
                                            <div
                                                key={index}
                                                onMouseEnter={() => setHoverIndex(index)}
                                                onMouseLeave={() => setHoverIndex(null)}
                                                className="relative flex items-center justify-between  text-[0.7rem] text-gray-700 bg-gray-100 px-2 py-1 rounded cursor-pointer"
                                            >
                                                <div className="flex items-center w-full">
                                                    <span
                                                        className="cursor-pointer text-gray-500 flex items-center gap-1"
                                                        onClick={() => window.open(`${fileUrl}`, "_blank")}
                                                    >

                                                        <img src={getFileIcon(file?.finalName)} alt="file icon" className="w-5 h-5 object-contain" />
                                                        {/* {file?.finalName} */}
                                                    </span>
                                                    <div className="flex flex-col items-start text-gray-600 ml-2 max-w-[50%]">
                                                        <div className="flex gap-2 text-xs">
                                                            <span className='font-bold'>{name}</span>
                                                            <span style={{ fontSize: '10px' }}>
                                                                {file?.date
                                                                    ? new Date(file.date).toLocaleDateString(undefined, {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "2-digit",
                                                                    })
                                                                    : ""}
                                                            </span>

                                                        </div>
                                                        <div className="text-[0.65rem] truncate max-w-full text-gray-500" title={file?.path}>
                                                            {file?.finalName}
                                                        </div>
                                                    </div>
                                                </div>
                                                {hoverIndex === index && (
                                                    <svg
                                                        onClick={() => handleTogglePopup(index)}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-caret-down-circle transition-opacity duration-200 cursor-pointer"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                                        <path d="M3.7 6.7a1 1 0 0 1 1.4 0L8 9.6l2.9-2.9a1 1 0 1 1 1.4 1.4l-3.6 3.6a1 1 0 0 1-1.4 0l-3.6-3.6a1 1 0 0 1 0-1.4z" />
                                                    </svg>
                                                )}

                                                {openIndex === index && (
                                                    <div
                                                        ref={dropattachmentRef}
                                                        onClick={() => deleteAttachementFile(file?.id)}
                                                        className="absolute w-full max-w-[40%] top-full right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg text-xs z-10 flex items-center"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="16"
                                                            height="16"
                                                            fill="currentColor"
                                                            className="bi bi-x"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                        </svg>
                                                        <button className="flex items-center px-2 py-1 hover:bg-gray-100 w-full text-left gap-2">
                                                            Delete
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}

                                </div>


                            </div>
                            <div className="mt-2 relative">
                                <div className="flex gap-6 border-b border-[#f5f5f5] text-xs">
                                    <button
                                        className={`py-2 px-0 border-b-2 font-bold bg-transparent ${activeTab === 'comments'
                                            ? 'border-[#1a7d3e] text-[#1a7d3e]'
                                            : 'border-transparent text-[#9ca3af]'
                                            }`}
                                        onClick={() => setActiveTab('comments')}
                                    >
                                        Comments
                                    </button>
                                </div>
                                <div className="py-3 text-[#757575] text-xs min-h-[40px]">
                                    {activeTab === 'comments' ? (
                                        comments.length === 0 ? (
                                            'No comments'
                                        ) : (
                                            <div className="space-y-4 ">
                                                {comments.map((c, idx) => {
                                                    const plainText = stripTags(c.comment);
                                                    const highlightedText = highlightMentions(
                                                        plainText
                                                            .split('\n')
                                                            .map((line) => line.trim())
                                                            .filter((line) => line.length)
                                                            .join('\n'),
                                                    ).replace(/\n/g, '<br/>');
                                                    const userName = c.User?.name || "";
                                                    return (
                                                        <li
                                                            key={c.id || idx}
                                                            ref={idx === comments.length - 1 ? lastCommentRef : null}
                                                            className="flex gap-3 items-start border-b pb-3"
                                                        >
                                                            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{ background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}>
                                                                {getUserInitials(userName)}
                                                            </div>
                                                            <div className="flex-1 w-50">
                                                                <div className="flex items-center gap-2">
                                                                    <span className="font-bold text-black">
                                                                        {toTitleCase(userName) || 'Admin'}
                                                                    </span>
                                                                    <span
                                                                        className="text-gray-500"
                                                                        style={{ fontSize: '10px' }}
                                                                    >
                                                                        {formatDateForDisplay(c.createdAt)}
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    className="mt-1 text-black text-sm break-words whitespace-pre-wrap"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightedText,
                                                                    }}
                                                                />
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </div>
                                        )
                                    ) : (
                                        <div className="space-y-4">
                                            {activityLog.map((a, idx) => (
                                                <li key={a.id || idx} className="flex gap-3 items-start border-b pb-3">
                                                    <div
                                                        className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-base min-w-[36px] min-h-[36px]"
                                                        style={{ justifyContent: 'center', background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}
                                                    >
                                                        {a.text?.[0]?.toUpperCase() || 'K'}
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="flex items-center gap-2">
                                                            <span className="font-bold text-black">
                                                                {a.text?.split(' ')[0] || 'User'}
                                                            </span>
                                                            <span className="text-xs text-gray-500">{a.time}</span>
                                                            <span className="w-2 h-2 bg-[#1a7d3e] rounded-full inline-block"></span>
                                                        </div>

                                                        <div className="mt-1 text-black text-sm">{a.text}</div>
                                                    </div>
                                                </li>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                        )}
                    </div>

                    {!showChecklistPanel && activeTab === 'comments' && (
                        <div
                            className="border-b border-solid border-gray-300 sticky bottom-0 left-0 bg-white relative flex items-start gap-2 py-2 bottom-0"
                            style={showUserDropdown ? { marginTop: '40px' } : {}}
                        >
                            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-base min-w-[36px] min-h-[36px]" style={{ background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)' }}>
                                {userInitial || 'K'}
                            </div>

                            <div className="flex-1 relative">
                                {showUserDropdown && (
                                    <div className="absolute -top-8 left-0 w-full z-30 user-dropdown-container">
                                        <DropDown
                                            autoFocus
                                            searchable={true}
                                            multi={false}
                                            options={allUser}
                                            values={selectedUsers ? selectedUsers : []}
                                            onChange={handleUserSelection}
                                            labelField="name"
                                            valueField="email"
                                            placeholder="Search users..."
                                            className="custom-user-select"
                                            dropdownHeight="200px"
                                            searchFn={({ props, state }) =>
                                                state.search
                                                    ? props.options.filter((user) =>
                                                        user.name.toLowerCase().includes(state.search.toLowerCase()),
                                                    )
                                                    : props.options
                                            }
                                            itemRenderer={({ item, methods }) => (
                                                <div
                                                    className="user-option"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '5px 10px',
                                                        cursor: 'pointer',
                                                        borderBottom: '1px solid #eee',
                                                    }}
                                                    onClick={() => methods.addItem(item)}
                                                >
                                                    <div
                                                        style={{
                                                            width: '24px',
                                                            height: '24px',
                                                            borderRadius: '50%',
                                                            backgroundColor: getColorForUser(item.name),
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bold',
                                                            marginRight: '10px',
                                                            textTransform: 'uppercase',
                                                        }}
                                                    >
                                                        {item.name ? item.name[0] : ''}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ fontWeight: '500' }}>{item.name}</div>
                                                    </div>
                                                </div>
                                            )}
                                            onDropdownClose={() => setShowUserDropdown(false)}
                                        />
                                    </div>
                                )}

                                <div className="flex items-center gap-2">
                                    <div className="flex-1 relative">
                                        <textarea
                                            id="comments"
                                            placeholder="Add a comment"
                                            className="w-full py-2 pl-3 pr-20 rounded border border-[#e0e8e3] text-sm focus:outline-none focus:border-[#1a7d3e] transition resize-none min-h-[36px]"
                                            value={commentInput}
                                            onChange={(e) => setCommentInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    if (commentInput.trim() === '') {
                                                        toast.error('Please enter a comment');
                                                        return;
                                                    }
                                                    handleAddComment();
                                                }
                                            }}
                                            rows={3}
                                            style={{ paddingRight: 60, backgroundColor: 'white' }}
                                            // disabled={!hasChatPermission}
                                        />

                                        <span
                                            className="absolute right-9 top-1/4 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-gray-600  bg-white px-1"
                                            style={{ pointerEvents: 'auto' }}
                                            onClick={toggleUserDropdown}
                                            title="Select users to mention"
                                        >
                                            @
                                        </span>

                                        <button
                                            className="absolute right-3 top-1/4 transform -translate-y-1/2 p-1 rounded-full flex items-center justify-center"
                                            style={{ color: '#1a7d3e' }}
                                            onClick={() => {
                                                if (commentInput.trim() === '') {
                                                    toast.error('Please enter a comment');
                                                    return;
                                                }
                                                handleAddComment();
                                            }}
                                            type="button"
                                            // disabled={!hasChatPermission}
                                        >
                                            <IoIosSend style={{ fontSize: '16px', color: '#1a7d3e' }} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {showArchiveConfirmation && (
                        <ConfirmationPopup
                            customMessage="Are you sure you want to complete this task?"
                            onCancel={handleCancelArchive}
                            deleteTaskMail={handleConfirmArchive}
                        />
                    )}
                    {confimationModal && (
                        <AppModal
                            show={confimationModal}
                            onClose={() => setConfimationModal(false)}
                            icon={<FiBriefcase size={18} color="#fff" />}
                            title="Task Trip"
                            subtitle="Choose how you want to proceed"
                            maxWidth="520px"
                            footer={
                                <button
                                    type="button"
                                    className="app-modal-btn-cancel"
                                    onClick={() => setConfimationModal(false)}
                                >
                                    Cancel
                                </button>
                            }
                        >
                            <div className="task-trip-modal__options">
                                <div
                                    className="task-trip-modal__option"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => {
                                        handleCreateNewTrip();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleCreateNewTrip();
                                        }
                                    }}
                                >
                                    <div className="task-trip-modal__option-main">
                                        <div className="task-trip-modal__option-icon" aria-hidden="true">
                                            <FiPlus size={18} />
                                        </div>
                                        <div className="task-trip-modal__option-text">
                                            <span className="task-trip-modal__option-title">Create New Trip</span>
                                            <span className="task-trip-modal__option-desc">
                                                Start from scratch and create a brand-new trip.
                                            </span>
                                        </div>
                                    </div>
                                    <FiChevronRight className="task-trip-modal__option-arrow" size={18} aria-hidden="true" />
                                </div>

                                <div
                                    className="task-trip-modal__option"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => {
                                        handleCloneTrip();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleCloneTrip();
                                        }
                                    }}
                                >
                                    <div className="task-trip-modal__option-main">
                                        <div className="task-trip-modal__option-icon" aria-hidden="true">
                                            <FiCopy size={18} />
                                        </div>
                                        <div className="task-trip-modal__option-text">
                                            <span className="task-trip-modal__option-title">Clone Existing Trip</span>
                                            <span className="task-trip-modal__option-desc">
                                                Duplicate an existing trip and modify it.
                                            </span>
                                        </div>
                                    </div>
                                    <FiChevronRight className="task-trip-modal__option-arrow" size={18} aria-hidden="true" />
                                </div>
                            </div>
                        </AppModal>
                    )}



                    {showTripList && (
                        <AppModal
                            show={showTripList}
                            onClose={handleCloseTripList}
                            icon={<FiBriefcase size={18} color="#fff" />}
                            title="Trip List"
                            subtitle="Trips linked to this task"
                            maxWidth="960px"
                            footer={
                                <button
                                    type="button"
                                    className="app-modal-btn-cancel"
                                    onClick={handleCloseTripList}
                                >
                                    Close
                                </button>
                            }
                        >
                            <div className="trip-list-modal">
                                <div className="app-data-table-card">
                                    <div className="app-data-table-wrap">
                                        <table className="app-data-table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" style={{ width: '5%' }}>S.No</th>
                                                    <th style={{ width: '15%' }}>Ref.</th>
                                                    <th style={{ width: '28%' }}>Title</th>
                                                    <th style={{ width: '15%' }}>Starts At</th>
                                                    <th style={{ width: '15%' }}>Ends At</th>
                                                    <th className="text-center" style={{ width: '10%' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={6}>
                                                            <div className="app-data-table__loading" role="status" aria-live="polite">
                                                                <div className="app-data-table__spinner" />
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    tripId?.map((trip, index) => (
                                                        <tr key={trip.id || index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>
                                                                {trip?.trip?.id?.slice(0, 6).toUpperCase()}
                                                            </td>
                                                            <td className="app-data-table__cell--title" title={trip?.trip?.title || '-'}>
                                                                {trip?.trip?.title || '-'}
                                                            </td>
                                                            <td>{moment(trip?.trip?.startDate).format('DD/MM/YYYY')}</td>
                                                            <td>{moment(trip?.trip?.endDate).format('DD/MM/YYYY')}</td>
                                                            <td>
                                                                <div className="d-flex justify-content-center">
                                                                    <button
                                                                        ref={(el) =>
                                                                        (actionButtonRefs.current[trip?.trip?.id] =
                                                                            el)
                                                                        }
                                                                        className="trip-list-modal__menu-btn"
                                                                        type="button"
                                                                            id={`dropdownMenuButton-${trip?.trip?.id}`}
                                                                            aria-expanded={
                                                                                openActionMenu === trip?.trip?.id
                                                                            }
                                                                            onClick={(e) => {
                                                                                if (openActionMenu === trip?.trip?.id) {
                                                                                    setOpenActionMenu(null);
                                                                                } else {
                                                                                    const rect = e.currentTarget.getBoundingClientRect();
                                                                                    const viewportHeight = window.innerHeight;
                                                                                    const viewportWidth = window.innerWidth;
                                                                                    const dropdownHeight = 300;
                                                                                    const dropdownWidth = 260;
                                                                                    const padding = 10;

                                                                                    const spaceBelow = viewportHeight - rect.bottom;
                                                                                    const spaceAbove = rect.top;

                                                                                    const placeAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

                                                                                    let top = placeAbove ? rect.top - dropdownHeight : rect.bottom;
                                                                                    top = Math.max(padding, Math.min(top, viewportHeight - dropdownHeight - padding));

                                                                                    const buttonCenter = rect.left + rect.width / 2;
                                                                                    let left = buttonCenter - dropdownWidth / 2;
                                                                                    left = Math.max(padding, Math.min(left, viewportWidth - dropdownWidth - padding));

                                                                                    setDropdownPosition({ top, left });
                                                                                    setOpenActionMenu(trip?.trip?.id);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FiMoreVertical fontSize={20} />
                                                                        </button>
                                                                        <ul
                                                                            className={`dropdown-menu ${openActionMenu === trip?.trip?.id
                                                                                ? "show"
                                                                                : ""
                                                                                }`}
                                                                            aria-labelledby={`dropdownMenuButton-${trip?.trip?.id}`}
                                                                            style={{
                                                                                position: "fixed",
                                                                                top: `${dropdownPosition.top}px`,
                                                                                left: `${dropdownPosition.left}px`,
                                                                                margin: "0px",
                                                                                minWidth: "220px",
                                                                                maxHeight: "80vh",
                                                                                overflowY: "auto",
                                                                                maxHeight: "80vh",
                                                                                overflowY: "auto",
                                                                                zIndex: 2000,
                                                                            }}
                                                                        >
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Link Status:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.linkStatus}
                                                                                    handleChange={() => {
                                                                                        handleUpdate(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Show Price:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.showPrice}
                                                                                    handleChange={() => {
                                                                                        handleUpdateShowPrice(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                            <li className="d-flex align-items-center justify-content-between px-3 py-2">
                                                                                <span className="fw-bold fs-8">
                                                                                    Show Detail Price:
                                                                                </span>
                                                                                <CustomSwitchButton
                                                                                    checked={trip?.trip?.showDetailPrice}
                                                                                    handleChange={() => {
                                                                                        handleUpdateShowDetailPrice(trip?.trip);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                />
                                                                            </li>

                                                                            <li className="dropdown-divider"></li>

                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    data-tooltip-id="my-tooltip"
                                                                                    data-tooltip-content="Edit"
                                                                                    data-tooltip-placement="top"
                                                                                    title="Edit"
                                                                                    onClick={() => {
                                                                                        const parentUrl = parentOrigin + `/tripboard/${trip?.trip?.id}`;
                                                                                        const newWin = window.open(parentUrl, "_blank");
                                                                                        setNewWindow(newWin);

                                                                                        const sendData = () => {
                                                                                            if (newWin && !newWin.closed) {
                                                                                                newWin.postMessage({
                                                                                                    type: "TASK_DATA",
                                                                                                    taskId: currentTaskId,
                                                                                                    editTask: true
                                                                                                }, parentOrigin);
                                                                                            }
                                                                                        };

                                                                                        const interval = setInterval(sendData, 500);
                                                                                        setTimeout(() => clearInterval(interval), 3000);

                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <FiEdit className="me-2" />Edit
                                                                                    Trip
                                                                                </button>
                                                                            </li>
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    onClick={() => {
                                                                                        setCopyData(trip?.trip);
                                                                                        setModal(true);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <FiCopy className="me-2" /> Copy
                                                                                    Trip
                                                                                </button>
                                                                            </li>
                                                                            <li>

                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    data-tooltip-id="my-tooltip"
                                                                                    data-tooltip-content=" View/Share Link"
                                                                                    data-tooltip-placement="top"
                                                                                    onClick={() => {
                                                                                        copyLinkHandler(trip?.trip?.id);
                                                                                    }}
                                                                                >
                                                                                    <FiLink className="me-2" /> View/Share Link
                                                                                </button>

                                                                            </li>
                                                                            {/* <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center"
                                                                                    onClick={() =>
                                                                                        openCancelModal(trip?.trip)
                                                                                    }
                                                                                >
                                                                                    <FiXCircle className="me-2" />{" "}
                                                                                    Cancel booking
                                                                                </button>
                                                                            </li> */}
                                                                            {PrivilegesChecker("Delete Trip") && (<>
                                                                            <li className="dropdown-divider"></li>
                                                                            <li>
                                                                                <button
                                                                                    className="dropdown-item d-flex align-items-center text-danger"
                                                                                    onClick={() => {
                                                                                        setDeleteID(trip?.trip?.id);
                                                                                        setModalShow(true);
                                                                                        setOpenActionMenu(null);
                                                                                    }}
                                                                                >
                                                                                    <MdDeleteOutline
                                                                                        className="me-2"
                                                                                        fontSize={20}
                                                                                    />{" "}
                                                                                    Delete Trip
                                                                                </button>
                                                                            </li>
                                                                            </>)}
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </AppModal>
                    )}

                </div>
            </div>
            <WarningModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                title={"Delete Trip"}
                handleYes={handleYes}
                className="btn btn-primary-new"
            />
            <Confirmation
                show={modal}
                onHide={() => setModal(false)}
                title={"Copy Tour"}
                handleYes={() => { setModal(false); handleCopy() }}
            />
            <CancelBookingModal
                show={showCancelModal}
                onHide={() => { setShowCancelModal(false), setOpenActionMenu(null) }}
                booking={selectedBookingTrip}
                type="Trip"
                setOpenActionMenu={setOpenActionMenu}
            />
            <Tooltip id="my-tooltip" />
        </>
    );
};

TaskData.propTypes = {
    gmailMassageID: PropTypes.string,
    taskItem: PropTypes.object.isRequired,
    updateTaskMail: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    getTaskMail: PropTypes.func.isRequired,
    setCurrentTask: PropTypes.func.isRequired,
    setTaskDetailModal: PropTypes.func.isRequired,
    onArchived: PropTypes.func,
};
export default TaskData;
